export const defaultI18n: { [key: string]: string } = {
    // PST Products Labels
    [i18nKeys.PSTWebApPlaybookLabel]: 'AP PLAYBOOK',
    [i18nKeys.PSTWebApStorytellingLabel]: 'AP STORYTELLING',

    // PST Document Title Products Labels
    [i18nKeys.PSTWebApPlaybookTitleLabel]: 'AP Playbook',
    [i18nKeys.PSTWebApStorytellingTitleLabel]: 'AP Storytelling',
    [i18nKeys.PSTWebPlaybookTitleLabel]: 'Playbook',
    [i18nKeys.PSTWebCastTitleLabel]: 'Cast',
    [i18nKeys.PSTWebSideBarTitleLabel]: 'Show/Hide Sidebar',
    [i18nKeys.PSTWebDarkThemeTitleLabel]: 'Dark Theme',
    [i18nKeys.PSTWebLightThemeTitleLabel]: 'Light Theme',
    [i18nKeys.PSTWebDiscoverTitleLabel]: 'Discover',

    // PST Navigation
    [i18nKeys.PSTWebViewSettingsTitle]: 'View Settings',
    [i18nKeys.PSTWebHideDetails]: 'Hide Details',
    [i18nKeys.PSTWebShowDetails]: 'Show Details',
    [i18nKeys.PSTWebCopyToClipboard]: 'Copy to clipboard',

    // PST Login Page
    [i18nKeys.PSTWebRememberCredentials]: 'Remember Me',
    [i18nKeys.PSTAutoLoginCredentials]: 'Auto Login',

    [i18nKeys.PSTWebUsernamePlaceholder]: 'Username',
    [i18nKeys.PSTWebPasswordPlaceholder]: 'Password',
    [i18nKeys.PSTWebLoginButton]: 'Login',
    [i18nKeys.PSTWebCollapseAllLabel]: 'Collapse All',
    [i18nKeys.PSTWebExpandAllLabel]: 'Expand All',
    // PST Session
    [i18nKeys.PSTWebSessionExpiredTitle]: 'Session expired',
    [i18nKeys.PSTWebSessionExpiredMessage]: 'Please, login again',

    // PST Top Bar
    [i18nKeys.PSTWebTeamSettingsLabel]: 'Team Settings',
    [i18nKeys.PSTWebCopyViewToClipboard]: 'Copy View To Clipboard',

    // PST Side Bar
    [i18nKeys.PSTWebNewSectionLabel]: 'New Section',
    [i18nKeys.PSTWebPadLockLabel]: 'Lock',
    [i18nKeys.PSTWebPadUnlockLabel]: 'Unlock',
    [i18nKeys.PSTWebPlusButtonLabel]: 'Add',
    [i18nKeys.PSTWebRenameRemoveTitle]: 'Rename/Remove',
    [i18nKeys.PSTWebRenameLabel]: 'Rename',
    [i18nKeys.PSTWebRemoveLabel]: 'Remove',
    [i18nKeys.PSTWebEditViewLabel]: 'Edit View',
    [i18nKeys.PSTWebDuplicateLabel]: 'Duplicate',
    [i18nKeys.PSTWebDuplicateAsTeamViewLabel]: 'Duplicate As Team View',

    // PST Search
    [i18nKeys.PSTWebSearchPlaceholder]: 'Search',
    [i18nKeys.PSTWebRangeLabel]: 'Range',

    // PST DIALOG ABOUT
    [i18nKeys.PSTWebDialogAboutPlatformLabel]: 'Platform',
    [i18nKeys.PSTWebDialogAboutVersionLabel]: 'Version',
    [i18nKeys.PSTWebDialogAboutDownloadErrorLog]: 'Download Error Log',
    [i18nKeys.PSTWebDialogAboutRights]: 'Associated Press All rights reserved',
    [i18nKeys.PSTWebDialogAboutCloseLabel]: 'Close',

    // PST Save Planning View Menu
    [i18nKeys.PSTWebSaveViewSettings]: 'Save',
    [i18nKeys.PSTWebSaveAsViewSettings]: 'Save As',
    [i18nKeys.PSTWebMakeDefaultView]: 'Make This My Default View',
    [i18nKeys.PSTWebBrowsePlanningViews]: 'Show All Views',
    [i18nKeys.PSTWebCreateNewView]: 'Create New View',
    [i18nKeys.PSTWebEditTeamSettings]: 'Edit Team Settings',

    [i18nKeys.PSTWebSaveAsTitleDefaultSuffix]: ' (copy)',

    // PST Team View Settings Menu
    [i18nKeys.PSTWebMakeTeamDefaultView]: "Make This the Team's Default View",
    [i18nKeys.PSTWebMakeGlobalDefaultView]: 'Make This the Global Default View',
    [i18nKeys.PSTWebSaveTeamViewSettings]: 'Save Team View Settings',
    [i18nKeys.PSTWebSaveAsTeamViewSettings]: 'Save As Team View',
    [i18nKeys.PSTWebBrowseTeamPlanningViews]: 'Show All Team Views',
    [i18nKeys.PSTWebCreateNewTeamView]: 'Create New Team View',
    [i18nKeys.PSTWebExitTeamSettings]: 'Exit Team Settings',

    [i18nKeys.PSTWebHideNavigationBar]: 'Hide Navigation Bar',
    [i18nKeys.PSTWebShowNavigationBar]: 'Show Navigation Bar',

    [i18nKeys.PSTWebMapSettingsBar]: 'Map Settings',

    [i18nKeys.PSTWebCreateNewViewTitle]: 'New View',
    [i18nKeys.PSTWebCreateNewViewShow]: 'Show',
    [i18nKeys.PSTWebCreateNewViewLayout]: 'Layout',
    [i18nKeys.PSTWebNewItemsToggleButton]: 'New Items',
    [i18nKeys.PSTWebCreateNewViewTopicRadio]: 'Topics',
    [i18nKeys.PSTWebCreateNewViewAssignmentRadio]: 'Assignments',
    [i18nKeys.PSTWebCreateNewViewTitlePlaceholder]: 'Title',

    [i18nKeys.PSTWebTopicsLabel]: 'Topics',
    [i18nKeys.PSTWebPublicationItemsLabel]: 'Publication Items',

    [i18nKeys.PSTWebStoriesLabel]: 'Stories',
    [i18nKeys.PSTWebRundownsLabel]: 'Rundowns',
    [i18nKeys.PSTWebSuggestedMediaLabel]: 'Suggested Media',
    [i18nKeys.PSTWebPluginsLabel]: 'Plugins',
    [i18nKeys.PSTWebPropertiesLabel]: 'Properties',

    // PST Personal Settings Menu
    [i18nKeys.PSTWebEditAvatar]: 'Edit',
    [i18nKeys.PSTWebPersonalSettings]: 'Personal Settings',
    [i18nKeys.PSTWebNotificationSettings]: 'Notification Settings',
    [i18nKeys.PSTWebHelp]: 'Help',
    [i18nKeys.PSTWebAbout]: 'About',
    [i18nKeys.PSTWebTeamMembers]: 'Team Members',
    [i18nKeys.PSTWebRegionAndLanguage]: 'Region and Language',
    [i18nKeys.PSTWebDefaultTimeZoneLabel]: 'Default Time Zone',
    [i18nKeys.PSTWebBrowserDefaultTimeZoneLabel]: 'Browser Default',
    [i18nKeys.PSTWebLanguageLabel]: 'Language',
    [i18nKeys.PSTWebDefaultLanguageLabel]: 'Default Language',
    [i18nKeys.PSTWebPublicationChannel]: 'Publication Channel',
    [i18nKeys.PSTWebRTLOriantation]: 'Right to Left Text Orientation',
    [i18nKeys.PSTWebLTROriantation]: 'Left to Right Text Orientation',
    [i18nKeys.PSTWebStartWeekDay]: 'Start Week Day',

    [i18nKeys.PSTWebLogout]: 'Sign Out',

    [i18nKeys.PSTWebRemoveNavigationSectionLabel]: 'Remove navigation section',
    [i18nKeys.PSTWebRemoveNavigationSectionText]: 'Are you sure you want to remove the {SECTION_LABEL} navigation section?',

    // PST Notification Settings Menu
    [i18nKeys.PSTWebNotificationDescription]: 'Send notification when I have a new Assignment',
    [i18nKeys.PSTWebNotificationMobileLabel]: 'Mobile App',
    [i18nKeys.PSTWebNotificationWebLabel]: 'Web',
    [i18nKeys.PSTWebNotificationTextLabel]: 'Text',
    [i18nKeys.PSTWebNotificationTextInputLabel]: 'Phone Number',
    [i18nKeys.PSTWebNotificationEmailLabel]: 'Email',
    [i18nKeys.PSTWebNotificationEmailInputLabel]: 'Email Address',

    // PSF Filter Panel
    [i18nKeys.PSTWebFilterLabel]: 'Filters',
    [i18nKeys.PSTWebRequiredFiltersLabel]: 'Required',
    [i18nKeys.PSTWebOptionalFiltersLabel]: 'Optional',
    [i18nKeys.PSTWebNoFiltersSelectedLabel]: 'No filters selected',
    [i18nKeys.PSTWebFilterRelationshipsLabel]: 'Relationships',
    [i18nKeys.PSTWebAssignmentsFilterLabel]: 'Assignments',
    [i18nKeys.PSTWebMissingAssignmentsFilterLabel]: 'Missing Assignments',
    [i18nKeys.PSTWebFilterRequiredLabel]: 'Required Filters',
    [i18nKeys.PSTWebFilterOptionalLabel]: 'Optional Filters',
    [i18nKeys.PSTWebRefineSearchLabel]: 'Refine search',
    [i18nKeys.PSTWebFirstX]: 'First {MAX_NUMBER} items shown - ',
    [i18nKeys.PSTWebLoadAll]: 'Load All',
    [i18nKeys.PSTWebPinFilterLabel]: 'Pin Filter',
    [i18nKeys.PSTWebDeleteFilterLabel]: 'Delete Filter',
    [i18nKeys.PSTWebAddFilterLabel]: 'Add Filter',

    // PST List Panel
    [i18nKeys.PSTWebSearchLabel]: 'Search',
    [i18nKeys.PSTWebGroupByWireProviderLabel]: 'Provider',
    [i18nKeys.PSTWebSearchResultsLabel]: 'Search Results',
    [i18nKeys.PSTWebGettingListLoaderLabel]: 'Getting list',
    [i18nKeys.PSTWebNewLabel]: 'New',
    [i18nKeys.PSTWebNewFeedLabel]: 'New Feed',
    [i18nKeys.PSTWebTemplateLabel]: 'Templates',
    [i18nKeys.PSTWebGroupByLabel]: 'Group By',
    [i18nKeys.PSTWebGroupByDateLabel]: 'Date',
    [i18nKeys.PSTWebGroupByTimeLabel]: 'Time',
    [i18nKeys.PSTWebSortByModTimeLabel]: 'Last Modified',
    [i18nKeys.PSTWebSortByAlphabeticalLabel]: 'Alphabetically By Slug',
    [i18nKeys.PSTWebSortByPubTimeLabel]: 'Published',
    [i18nKeys.PSTWebGroupByChannelLabel]: 'Channel',
    [i18nKeys.PSTWebGroupByOwnerLabel]: 'Owner',
    [i18nKeys.PSTWebGroupByStatusLabel]: 'Status',
    [i18nKeys.PSTWebGroupByDepartmentLabel]: 'Desk',
    [i18nKeys.PSTWebGroupByRoleLabel]: 'My Role',

    [i18nKeys.PSTWebGroupByWireCategoryLabel]: 'Category',
    [i18nKeys.PSTWebGroupByWireTypeLabel]: 'Wire Type',
    [i18nKeys.PSTWebViewLabel]: 'Layout',
    [i18nKeys.PSTWebSortByLabel]: 'Sort By',
    [i18nKeys.PSTWebSortOrderLabel]: 'Sort Order',
    [i18nKeys.PSTWebGroupSortOrderLabel]: 'Group Sort Order',
    [i18nKeys.PSTWebViewCardsLabel]: 'Cards',
    [i18nKeys.PSTWebViewCardLabel]: 'Card',
    [i18nKeys.PSTWebViewCondensedLabel]: 'Condensed',
    [i18nKeys.PSTWebViewListLabel]: 'List',
    [i18nKeys.PSTWebViewTimelineLabel]: 'Tile',
    [i18nKeys.PSTWebViewMapLabel]: 'Map',
    [i18nKeys.PSTWebViewTrendsLabel]: 'Trends',
    [i18nKeys.PSTWebViewTileLabel]: 'Tile',
    [i18nKeys.PSTWebOwnersLabel]: 'Owners',
    [i18nKeys.PSTWebSlugLabel]: 'Slug',
    [i18nKeys.PSTWebTitleLabel]: 'Title',
    [i18nKeys.PSTWebSummaryLabel]: 'Summary',
    [i18nKeys.PSTWebDescriptionLabel]: 'Description',
    [i18nKeys.PSTWebStatusLabel]: 'Status',
    [i18nKeys.PSTWebSelectStatusLabel]: 'Select Status',
    [i18nKeys.PSTWebDesksLabel]: 'Desks',
    [i18nKeys.PSTWebAssignmentsLabel]: 'Assignments',
    [i18nKeys.PSTWebNewItemLabel]: 'New Item',
    [i18nKeys.PSTWebNewItemsLabel]: 'New Items',
    [i18nKeys.PSTWebMyNewTopics]: 'Newly Created Items',
    [i18nKeys.PSTWebRemoveDate]: 'Remove Date',
    [i18nKeys.PSTWebSettingsBar]: 'Settings',
    [i18nKeys.PSTWebSettingsApproveLabel]: 'Approve',
    [i18nKeys.PSTWebCastTargetPublicationDT]: 'Target Publication Date and Time',
    [i18nKeys.PSTWebCustomFieldLabel]: 'Custom Field',

    // PST Controls
    [i18nKeys.PSTWebSaveButtonLabel]: 'Save',
    [i18nKeys.PSTWebSaveAndNextButtonLabel]: 'Save & Next',
    [i18nKeys.PSTWebSaveAsTemplateButtonLabel]: 'Save as Template',
    [i18nKeys.PSTWebCancelButtonLabel]: 'Cancel',
    [i18nKeys.PSTWebCloseButtonLabel]: 'Close',
    [i18nKeys.PSTWebBackButtonLabel]: 'Back',
    [i18nKeys.PSTWebConfirmButtonLabel]: 'Confirm',
    [i18nKeys.PSTWebBrowseButtonLabel]: 'Browse',
    [i18nKeys.PSTWebApplyButtonLabel]: 'Apply',
    [i18nKeys.PSTWebOkButtonLabel]: 'Ok',
    [i18nKeys.PSTWebInsertButtonLabel]: 'Insert',
    [i18nKeys.PSTWebStaffIDPlaceholder]: 'Story Owner',
    [i18nKeys.PSTWebSlugPlaceholder]: 'Slug',
    [i18nKeys.PSTWebSummaryPlaceholder]: 'Summary',
    [i18nKeys.PSTWebStatusPlaceholder]: 'Status',
    [i18nKeys.PSTWebDeskPlaceHolder]: 'Desk',
    [i18nKeys.PSTWebTopicTypePlaceholder]: 'Type',
    [i18nKeys.PSTWebModifiedPlaceholder]: '5 minutes ago',
    [i18nKeys.PSTWebNotesLabel]: 'Notes',
    [i18nKeys.PSTWebNotesPlaceholder]: 'Add notes here',
    [i18nKeys.PSTWebAllOption]: 'All',
    [i18nKeys.PSTWebAnyOption]: 'Any',
    [i18nKeys.PSTWebNotAppliedOption]: 'Not Applied',
    [i18nKeys.PSTWebNotAssignedOption]: 'Not Assigned',
    [i18nKeys.PSTWebMeOption]: 'Me',
    [i18nKeys.PSTWebBlankOption]: 'Blank',
    [i18nKeys.PSTWebTodayOption]: 'Today',
    [i18nKeys.PSTWebTomorrowOption]: 'Tomorrow',
    [i18nKeys.PSTWebYesOption]: 'Yes',
    [i18nKeys.PSTWebNoOption]: 'No',
    [i18nKeys.PSTWebValueLabel]: 'Value',
    [i18nKeys.PSTWebThisWeekOption]: 'This Week',
    [i18nKeys.PSTWebNextWeekOption]: 'Next Week',
    [i18nKeys.PSTWebWeekAfterNextOption]: 'Week After Next',
    [i18nKeys.PSTWebTodayPlusMinusFiveOption]: 'Today +/- 5',
    [i18nKeys.PSTWebFutureOption]: 'All Future',
    [i18nKeys.PSTWebTodayPlusFiveOption]: 'Today + 5',
    [i18nKeys.PSTWebTodayPlusSevenOption]: 'Today + 7',
    [i18nKeys.PSTWebDateNotAvailableOption]: 'N/A',
    [i18nKeys.PSTWebAssignmentOwnerLabel]: 'Journalist',
    [i18nKeys.PSTWebAssignmentAddLabel]: 'Assignment',
    [i18nKeys.PSTWebCostTypeColumnLabel]: 'Cost Type',
    [i18nKeys.PSTWebCostColumnLabel]: 'Cost',
    [i18nKeys.PSTWebCostCurrencyLabel]: '$',
    [i18nKeys.PSTWebClearAllLabel]: 'Clear All',
    [i18nKeys.PSTWebClearAllItemsLabel]: 'Clear All Items',
    [i18nKeys.PSTWebCreateNewTemplateTitlePlaceholder]: 'Title',
    [i18nKeys.PSTWebCreateNewTemplateLabel]: 'New Template',
    [i18nKeys.PSTWebSaveAsTeam]: 'Save as team',
    [i18nKeys.PSTWebSaveAsEnterprise]: 'Save as enterprise',
    [i18nKeys.PSTWebLoadingLabel]: 'Loading...',
    [i18nKeys.PSTWebCreateNewViewLabel]: 'Create View',
    [i18nKeys.PSTWebUpdateViewLabel]: 'Update View',
    [i18nKeys.PSTWebDatePickerClearLabel]: 'Clear',
    [i18nKeys.PSTWebTimeLabel]: 'Time',
    [i18nKeys.PSTWebNextLabel]: 'Next',
    [i18nKeys.PSTWebSelectAllLabel]: 'Select All',
    [i18nKeys.PSTWebSectionNameLabel]: 'Section name',
    [i18nKeys.PSTWebStartDateLabel]: 'Start date',
    [i18nKeys.PSTWebEndDateLabel]: 'End date',
    [i18nKeys.PSTWebPinItemButtonLabel]: 'Pin item',
    [i18nKeys.PSTWebSaveOption]: 'Save',
    [i18nKeys.PSTWebDiscardOption]: 'Discard',

    // PST Address Form
    [i18nKeys.PSTWebAddressDetails]: 'Details',
    [i18nKeys.PSTWebFormattedAddressPlaceholder]: 'Location',
    [i18nKeys.PSTWebFormattedAddressLabel]: 'Add Address',

    [i18nKeys.PSTWebStreetAddressPlaceholder]: 'Street Address',
    [i18nKeys.PSTWebLocationNamePlaceholder]: 'Location Name',
    [i18nKeys.PSTWebCityPlaceholder]: 'City',
    [i18nKeys.PSTWebStatePlaceholder]: 'State',
    [i18nKeys.PSTWebCountryPlaceholder]: 'Country',

    [i18nKeys.PSTWebCustomCardStreetAddressPlaceholder]: 'Address - Street Address',
    [i18nKeys.PSTWebCustomCardLocationNamePlaceholder]: 'Address - Location Name',
    [i18nKeys.PSTWebCustomCardCityPlaceholder]: 'Address - City',
    [i18nKeys.PSTWebCustomCardStatePlaceholder]: 'Address - State',
    [i18nKeys.PSTWebCustomCardCountryPlaceholder]: 'Address - Country',

    // PST Topic hover button texts
    [i18nKeys.PSTWebTopicHoverDeleteText]: 'Delete',
    [i18nKeys.PSTWebTopicHoverDuplicateText]: 'Duplicate',
    [i18nKeys.PSTWebTopicHoverCloneText]: 'Clone',
    [i18nKeys.PSTWebTopicHoverExpandText]: 'Show Details',
    [i18nKeys.PSTWebTopicHoverSaveAsTemplateText]: 'Save as Template',
    [i18nKeys.PSTWebTopicHoverCopyUrlToClipboardText]: 'Copy Topic Link to Clipboard',
    [i18nKeys.PSTWebAssignmentHoverCopyUrlToClipboardText]: 'Copy Assignment Link to Clipboard',
    [i18nKeys.PSTWebAddNewTopicText]: 'Add New Topic',

    [i18nKeys.PSTWebTimeZoneLabel]: 'Time Zone',

    // PST Panes
    [i18nKeys.PSTWebTagsPane]: 'Tags',
    [i18nKeys.PSTWebCoverageAssignmentsPane]: 'Coverage Assignments',
    [i18nKeys.PSTWebAttachmentsPane]: 'Attachments',
    [i18nKeys.PSTWebContactsPane]: 'Contacts',
    [i18nKeys.PSTWebLinksPane]: 'Linked Objects',
    [i18nKeys.PSTWebAssignmentDetails]: 'Assignment Details',
    [i18nKeys.PSTWebStoriesPane]: 'Stories',

    [i18nKeys.PSTWebListValue_PSTCoverageType_Text]: 'Text',
    [i18nKeys.PSTWebListValue_PSTCoverageType_Photo]: 'Photo',
    [i18nKeys.PSTWebListValue_PSTCoverageType_Video]: 'Video',
    [i18nKeys.PSTWebListValue_PSTCoverageType_LiveVideo]: 'Live Video',
    [i18nKeys.PSTWebListValue_PSTCoverageType_Audio]: 'Audio',
    [i18nKeys.PSTWebListValue_PSTCoverageType_Graphic]: 'Graphic',
    [i18nKeys.PSTWebListValue_PSTCoverageType_Interactive]: 'Interactive',
    [i18nKeys.PSTWebListValue_PSTCoverageType_SocialPromotion]: 'Social Promotion',

    // PST Timeline Day labels (Display names)
    [i18nKeys.PSTWebMonday]: 'Monday',
    [i18nKeys.PSTWebTuesday]: 'Tuesday',
    [i18nKeys.PSTWebWednesday]: 'Wednesday',
    [i18nKeys.PSTWebThursday]: 'Thursday',
    [i18nKeys.PSTWebFriday]: 'Friday',
    [i18nKeys.PSTWebSaturday]: 'Saturday',
    [i18nKeys.PSTWebSunday]: 'Sunday',

    // PST Timeline Day labels (Display names)
    [i18nKeys.PSTWebMON]: 'MON',
    [i18nKeys.PSTWebTUE]: 'TUE',
    [i18nKeys.PSTWebWED]: 'WED',
    [i18nKeys.PSTWebTHU]: 'THU',
    [i18nKeys.PSTWebFRI]: 'FRI',
    [i18nKeys.PSTWebSAT]: 'SAT',
    [i18nKeys.PSTWebSUN]: 'SUN',

    // PST Planning Views & Searches
    [i18nKeys.PSTWebPlanningViewsLabel]: 'Planning Views and Searches',
    [i18nKeys.PSTWebPlanningViewsPaneLabel]: 'Views',
    [i18nKeys.PSTWebSearchesPaneLabel]: 'Searches',
    [i18nKeys.PSTWebCreateDateLabel]: 'Created on',
    [i18nKeys.PSTWebRemoveFromNavigation]: 'Remove From Navigation',
    [i18nKeys.PSTWebAddToNavigation]: 'Add To Navigation',
    [i18nKeys.PSTWebDeleteViewState]: 'Delete',
    [i18nKeys.PSTWebDeletePlanningItemLabel]: 'WARNING: Deleting the view will remove it from the system permanently, this includes other navigation bars using this view!',
    [i18nKeys.PSTWebCreatedInLabel]: 'Created In',
    [i18nKeys.PSTWebGlobalLabel]: 'Global',
    [i18nKeys.PSTWebPersonalLabel]: 'Personal',
    [i18nKeys.PSTWebAllLabel]: 'All',

    // PST View State
    [i18nKeys.PSTWebDefLayoutLabel]: 'Default Layout',
    [i18nKeys.PSTWebContentSortOrder]: 'Content Sort Order',
    [i18nKeys.PSTWebDefContGroupByCriteriaLabel]: 'Default Content Group By Criteria',
    [i18nKeys.PSTWebDefContSortByCriteriaLabel]: 'Default Content Sort By Criteria',
    [i18nKeys.PSTWebAddViewTitleLabel]: 'Add View Title ...',
    [i18nKeys.PSTWebContentTypeLabel]: 'Content Type',
    [i18nKeys.PSTWebAdvancedSettingsLabel]: 'Advanced Settings',
    [i18nKeys.PSTWebAddToViewLabel]: 'Add To View',
    [i18nKeys.PSTWebRemoveAllLabel]: 'Remove All',
    [i18nKeys.PSTWebAddContentSourceLabel]: 'Add Content Source',
    [i18nKeys.PSTWebContentLabel]: 'Content',
    [i18nKeys.PSTWebSelectContentSourceLabel]: 'Select Content Source(s)',
    [i18nKeys.PSTWebSingleContentViewSourceLabel]: 'Single Content View Source',
    [i18nKeys.PSTWebMultipleContentViewSourceLabel]: 'Multiple Content View Source',
    [i18nKeys.PSTWebBrowseLabel]: 'Browse',
    [i18nKeys.PSTWebConfigureLabel]: 'Configure',
    [i18nKeys.PSTWebTotalResultsLabel]: 'Total Results',

    // PST Confirmation Messages
    [i18nKeys.PSTWebConfirmDeleteKey]: 'key',
    [i18nKeys.PSTWebConfirmDeleteLabel]: 'Delete Item',
    [i18nKeys.PSTWebConfirmDeletePart1]: 'Are you sure you want to delete the ',
    [i18nKeys.PSTWebConfirmUnfreezePages]: 'Are you sure you want to remove the Freeze Page numbers setting? ',
    [i18nKeys.PSTWebConfirmFreezePages]: 'Freezing pages when MOS Control Active may disrupt your MOS playlist. Do you want to proceed? ',
    [i18nKeys.PSTWebConfirmCancel]: 'Are you sure you wish to discard your changes?',
    [i18nKeys.PSTWebConfirmCancelShort]: 'Discard Changes?',
    [i18nKeys.PSTWebConfirmDeleteTopicPart2]: ' topic?',
    [i18nKeys.PSTWebConfirmDeleteAssignmentPart2]: ' assignment?',
    [i18nKeys.PSTWebConfirmDeleteStoryPart2]: ' story?',
    [i18nKeys.PSTWebConfirmDeleteTemplatePart2]: ' template?',
    [i18nKeys.PSTWebConfirmSaveAsTemplatePart1]: 'Are you sure you want to save as temlate the ',
    [i18nKeys.PSTWebConfirmSaveAsTemplatePart2]: ' topic?',
    [i18nKeys.PSTWebConfirmChangeTopicGroup]: 'This item has multiple values in field {fieldName}. Dropping this here will remove the value where it is dragged from. Do you want to proceed ?',
    [i18nKeys.PSTWebClipboardModalTitle]: 'Choose Clipboard Template',
    [i18nKeys.PSTWebClipboardModalPersonal]: 'Personal',
    [i18nKeys.PSTWebClipboardModalTeam]: 'Team',
    [i18nKeys.PSTWebClipboardModalEnterprise]: 'Enterprise',
    [i18nKeys.PSTWebConfirmDeletePublcationItem]: 'publication item?',
    [i18nKeys.PSTWebConfirmDeleteStoryPart3]: ' It will be removed from any topics and/or rundowns.',
    [i18nKeys.PSTWebConfirmSaveShort]: 'Unsaved Changes',
    [i18nKeys.PSTWebConfirmSave]: 'There are unsaved changes. Do you wish to save them?',

    // PST Slideshow Labels
    [i18nKeys.PSTWebPlanningViewType]: 'Type',
    [i18nKeys.PSTWebSingleViewLabel]: 'Single View',
    [i18nKeys.PSTWebSlideshowViewLabel]: 'Slideshow',
    [i18nKeys.PSTWebRefineSlideshowLabel]: 'Refine',
    [i18nKeys.PSTWebSlideshowDelayLabel]: 'Delay',
    [i18nKeys.PSTWebSlideshowIncludeInLabel]: 'Include in Slideshow',
    [i18nKeys.PSTWebSecondsLabel]: 'seconds',
    [i18nKeys.PSTWebSlideshowsPaneLabel]: 'Slideshows',

    // PST Manage Team Members
    [i18nKeys.PSTWebMTMLabel]: 'Manage Team Members',
    [i18nKeys.PSTWebMTMPendingLabel]: 'Pending',
    [i18nKeys.PSTWebMTMActiveLabel]: 'Active',
    [i18nKeys.PSTWebUserGroupSortByStatusLabel]: 'Status',
    [i18nKeys.PSTWebUserGroupSortByRoleLabel]: 'My Role',
    [i18nKeys.PSTWebUserGroupSortByProgramLabel]: 'Program',
    [i18nKeys.PSTWebUserGroupSortByIDLabel]: 'ID',
    [i18nKeys.PSTWebUserGroupSortByFirstNameLabel]: 'First Name',
    [i18nKeys.PSTWebUserGroupSortByLastNameLabel]: 'Last Name',
    [i18nKeys.PSTWebUserGroupSortByEmailLabel]: 'Email',
    [i18nKeys.PSTWebUserHeaderAvatarLabel]: 'Avatar',
    [i18nKeys.PSTWebUserHeaderStatusLabel]: 'Status',
    [i18nKeys.PSTWebUserHeaderInvitationLabel]: 'Invitation',
    [i18nKeys.PSTWebUserHeaderRoleLabel]: 'My Role',
    [i18nKeys.PSTWebUserHeaderDefaultTeamLabel]: 'Default Team',
    [i18nKeys.PSTWebUserHeaderIDLabel]: 'Member ID',
    [i18nKeys.PSTWebUserHeaderFirstNameLabel]: 'First Name',
    [i18nKeys.PSTWebUserHeaderLastNameLabel]: 'Last Name',
    [i18nKeys.PSTWebUserHeaderEmailLabel]: 'Email',
    [i18nKeys.PSTWebUserHeaderSSOEmailLabel]: 'SSO Logins',
    [i18nKeys.PSTWebSendInvitationButtonLabel]: 'Invite',
    [i18nKeys.PSTWebSendedInvitationButtonLabel]: 'Activated',
    [i18nKeys.PSTWebResendInvitationButtonLabel]: 'Resend',
    [i18nKeys.PSTWebNewTeamMembersLabel]: 'New Team Members',
    [i18nKeys.PSTWebAddNewTeamMemberLabel]: 'Add New Team Member',
    [i18nKeys.PSTWebAllTeamMembersLabel]: 'Active Members',
    [i18nKeys.PSTWebPendingTeamMembersLabel]: 'Pending Invitations',
    [i18nKeys.PSTWebConfirmDeleteUserLabel]: 'Delete user',
    [i18nKeys.PSTWebConfirmDeleteUserMessage]: 'Are you sure you want to remove user: ',
    [i18nKeys.PSTWebNewMemberLabel]: 'New Member',
    [i18nKeys.PSTWebSaveMemberLabel]: 'Confirm',
    [i18nKeys.PSTSystemConfiguration]: 'System Configuration',

    // Manage publication channels
    [i18nKeys.PSTWebMPCHLabel]: 'Manage Publication Channels',
    [i18nKeys.PSTWebNPCHLabel]: 'New Publication Channel',
    [i18nKeys.PSTWebWorkFlowLabel]: 'Workflow Action',
    [i18nKeys.PSTWebScheduleLabel]: 'Schedule',
    [i18nKeys.PSTWebPublicationChannelName]: 'Name',
    [i18nKeys.PSTWebNameLabel]: 'Name',
    [i18nKeys.PSTWebNameOfTeamLabel]: 'Name of the Team',
    [i18nKeys.PSTWebPublicationChannelSections]: 'Sections',

    [i18nKeys.PSTWebConfirmDeletePublicationLabel]: 'Delete publication',
    [i18nKeys.PSTWebConfirmDeletePublicationMessage]: 'Are you sure you want to remove the publication?',

    [i18nKeys.PSTWebConfirmDeleteSectionLabel]: 'Delete section',
    [i18nKeys.PSTWebConfirmDeleteSectionMessage]: 'Are you sure you want to remove the section?',

    [i18nKeys.PSTWebConfirmAddAllItemsLabel]: 'Add all items',
    [i18nKeys.PSTWebConfirmAddAllItemsMessage]: 'Are you sure you want to add all items to the first section of the publication list?',

    [i18nKeys.PSTWebConfirmClearPublicationListLabel]: 'Clear publication list',
    [i18nKeys.PSTWebConfirmClearPublicationListMessage]: 'Are you sure you want to clear the publication list?',

    [i18nKeys.PSTWebConfirmAddPublicationToRestrictedChannelLabel]: 'Add publication',
    [i18nKeys.PSTWebConfirmAddPublicationToRestrictedChannelMessage]:
        'You cannot take this action because item "{publicationName}" is already in list {publicationLists}. Do you want to add the item anyway?',
    [i18nKeys.PSTWebConfirmAddPublicationsToRestrictedChannelMessage]: 'You cannot take this action because several items are already in a restricted list. Do you want to add them anyway?',

    [i18nKeys.PSTWebConfirmEditPublicationChannelMissingValueLabel]: 'Missing Value',
    [i18nKeys.PSTWebConfirmEditPublicationChannelMessage]: "Leaving '{prop}' empty is not allowed.",

    // PST Attachments list
    [i18nKeys.PSTWebAttachmentsListDragFile]: 'Drag file here to upload or ',
    // PST attachment rename
    [i18nKeys.PSTWebAttachmentRenameModalTitle]: 'File Name (maximum 50 symbols)',
    [i18nKeys.PSTWebAttachmentRenameModalInputLabel]: 'Attachment Name',

    // PST Native Android
    [i18nKeys.PSTWebFileSelectOptionsTitle]: 'Select Action',
    [i18nKeys.PSTWebFileSelectBrowseFiles]: 'Browse files',
    [i18nKeys.PSTWebFileSelectCapturePhoto]: 'Capture photo from camera',

    [i18nKeys.PSTWebDownloading]: 'Downloading...',

    // Map layout
    [i18nKeys.PSTWebZoomToCoverageLabel]: 'Zoom to Coverage',
    [i18nKeys.PSTWebShowTeamLocationsLabel]: 'Show Team Locations',
    [i18nKeys.PSTWebLockMapLocationLabel]: 'Lock Map Location',

    [i18nKeys.PSTWebUploadFileNameTooLong]: 'You cannot attach files with a name longer than 50 characters.',

    [i18nKeys.PSTWebSortOrderTooltipASC]: 'Ascending',
    [i18nKeys.PSTWebSortOrderTooltipDESC]: 'Descending',

    [i18nKeys.PSTWebAttachmentOverLimitLabel]: 'Attachment size exceeded',
    [i18nKeys.PSTWebAttachmentOverLimitText]: 'You cannot attach files bigger than ',
    [i18nKeys.PSTWebAllowedFileSizeText]: 'Allowed file size:',
    [i18nKeys.PSTWebErrorUploadingFileLabel]: 'Upload file rejected',
    [i18nKeys.PSTWebAllowedFileTypesText]: 'Allowed file types:',

    [i18nKeys.PSTWebOpenFullScreenText]: 'Open Fullscreen',
    [i18nKeys.PSTWebOpenText]: 'Open',
    [i18nKeys.PSTWebChangedAgoLabel]: 'Updated',
    [i18nKeys.PSTWebChangedByLabel]: 'by',
    [i18nKeys.PSTWebWordsLabel]: 'words',
    [i18nKeys.PSTWebAddToTopicLabel]: 'Add to Topic',
    [i18nKeys.PSTWebAddToRundownLabel]: 'Add to Rundown',

    // Draft
    [i18nKeys.PSTStaffIDPlaceholder]: 'Draft Owner',

    // PST Topic Custom Card Fields
    [i18nKeys.PSTWebSaveAsTeamDefault]: 'Save as team default',
    [i18nKeys.PSTWebSaveAsEnterpriseDefault]: 'Save as enterprise default',
    [i18nKeys.PSTWebCustomizeTopicCard]: 'Customize Topic Card',
    [i18nKeys.PSTWebSelectFieldLabel]: 'Select field',

    // Cast
    [i18nKeys.PSTWebStorytellingObjectsLabel]: 'Objects',
    [i18nKeys.PSTWebSavedViewsLabel]: 'Saved Views',
    [i18nKeys.PSTWebCastSearchTabLabel]: 'Search',
    [i18nKeys.PSTWebSavedViewsTabLabel]: 'Saved',
    [i18nKeys.PSTWebRevisionsLabel]: 'Revisions',
    [i18nKeys.PSTWebPublishLabel]: 'Publish',
    [i18nKeys.PSTWebEditSectionsLabel]: 'Edit Sections',
    [i18nKeys.PSTWebSectionsLabel]: 'Sections',
    [i18nKeys.PSTWebCancelEditSectionsLabel]: 'Cancel Editing',
    [i18nKeys.PSTWebSaveSectionsLabel]: 'Save Sections',
    [i18nKeys.PSTWebCreateNewRevisionLabel]: 'Create New Revision',
    [i18nKeys.PSTWebNotPublished]: 'Not Published',
    [i18nKeys.PSTWebPublishedAt]: 'Published at ',
    [i18nKeys.PSTWebPublishedAtByPSTWebPublishedAtBy]: 'Published at {publicationDate} by {userName}',
    [i18nKeys.PSTWebPublishingStatus]: 'Status: ',
    [i18nKeys.PSTWebChannelScheduleNotSupportedLabel]: 'Channel Schedule not supported',
    [i18nKeys.PSTWebChannelScheduleNotSupportedDetailLabel]: 'Cast supports only Daily Channel Schedule at this time. Your view has the following channel schedule configured: ',
    [i18nKeys.PSTWebPublicationListTitle]: 'List Title',
    [i18nKeys.PSTWebPublicationChannelEditionNames]: 'Edition Names',
    [i18nKeys.PSTWebPublicationChannelEditionName]: 'Edition Name',
    [i18nKeys.PSTWebPublicationChannelShowTopics]: 'Show Topics',
    [i18nKeys.PSTWebPublicationChannelShowAssignments]: 'Show Assignments',
    [i18nKeys.PSTWebPublicationChannelShowStories]: 'Show Stories',
    [i18nKeys.PSTWebPublicationChannelRemoveAddedRecords]: 'Remove Added Records',
    [i18nKeys.PSTWebAddAllLabel]: 'Add All',
    [i18nKeys.PSTWebCastObjectsDropDownLabel]: 'View',
    [i18nKeys.PSTWebCastObjectsCreatedBy]: 'Created By',
    [i18nKeys.PSTWebCastObjectsOpenButton]: 'Open',

    [i18nKeys.PSTWebCastLinkViolationErrorLabel]: 'This Object cannot be deleted because it is included in a Publication List. It presents in the following:',
    [i18nKeys.PSTWebErrorDeletingLabel]: 'Error deleting object',

    [i18nKeys.PSTWebCastErrorEditingSectionLabel]: 'Error editing section',
    [i18nKeys.PSTWebCastSectionExistedText]: 'Section with that title already exists',
    [i18nKeys.PSTWebCastSectionEmptyText]: 'The Section title cannot be empty',

    [i18nKeys.PSTWebChannelLabel]: 'Channel',
    [i18nKeys.PSTWebDefaultViewLabel]: 'Default view',
    [i18nKeys.PSTWebViewSettingsLabel]: 'View Settings',

    [i18nKeys.PSTWebWireFlagTooltip]: 'Create Topic',
    [i18nKeys.PSTWebWireTopicFromWireNavigateTooltip]: 'Create and show new Topic',

    // Discover Wire Attachments full-screen
    [i18nKeys.PSTWebWireAttachmentsMediaName]: 'Media Name',
    [i18nKeys.PSTWebWireAttachmentsMediaType]: 'Media Type',
    [i18nKeys.PSTWebWireAttachmentsExitMediaMode]: 'Exit Media Mode',
    [i18nKeys.PSTWebWireFullScreenGallery]: 'Gallery',
    [i18nKeys.PSTWebWireFullScreenStory]: 'Story',
    [i18nKeys.PSTWebCreateNewDiscoverWireLabel]: 'Create New Discover Wire',
    [i18nKeys.PSTWebAttachDiscoverWireLabel]: 'Attach to an existing Discover Wire',
    [i18nKeys.PSTWebWireFullScreenWords]: 'Words',
    [i18nKeys.PSTWebWireFullScreenAuthor]: 'Posted by',
    [i18nKeys.PSTWebWireFullScreenAttachTo]: 'Attach To',

    // Discover Admin panel
    [i18nKeys.PSTWebDiscoverAdminSettingsLabel]: 'Admin Settings',
    [i18nKeys.PSTWebDiscoverCredentialsLabel]: 'Credentials',
    [i18nKeys.PSTWebDiscoverFeedsLabel]: 'Feeds',
    [i18nKeys.PSTWebDiscoverAddButton]: 'Add',
    [i18nKeys.PSTWebDiscoverCreateFeedLabel]: 'Create Feed',

    // Discover Admin Panel Credentials
    [i18nKeys.PSTWebDiscoverNewAccessTokenLabel]: 'Add New Access Token',
    [i18nKeys.PSTWebDiscoverEditAccessTokenLabel]: 'Editing Access Token',
    [i18nKeys.PSTWebDiscoverNewFeedLabel]: 'Add New Feed Setup',
    [i18nKeys.PSTWebDiscoverEditFeedLabel]: 'Editing Feed Setup',

    [i18nKeys.PSTWebDiscoverAddTokenNameLabel]: 'Add Name',
    [i18nKeys.PSTWebDiscoverAddFeedNameLabel]: 'Add New Feed Setup Name',
    [i18nKeys.PSTWebDiscoverAPIKeyLabel]: 'Enter API Key...',
    [i18nKeys.PSTWebDiscoverCreateButton]: 'Create',
    [i18nKeys.PSTWebDiscoverEditButton]: 'Save Changes',

    // Stepper
    [i18nKeys.PSTWebDiscoverChooseFeedSourceLabel]: 'Choose Feed Source',
    [i18nKeys.PSTWebDiscoverSelectAccessTokenLabel]: 'Select Access Token',
    [i18nKeys.PSTWebDiscoverSelectProductsLabel]: 'Select Products',

    [i18nKeys.PSTWebDiscoverTokenConfigurationLabel]: 'Token Configuration',
    [i18nKeys.PSTWebDiscoverTokenNameLabel]: 'Token Name',

    [i18nKeys.PSTWebDiscoverURLLabel]: 'URL',
    [i18nKeys.PSTWebDiscoverEnterURLLabel]: 'Enter URL...',
    [i18nKeys.PSTWebDiscoverEnterURLHereLabel]: 'Enter URL here',
    [i18nKeys.PSTWebDiscoverPasswordLabel]: 'Password',
    [i18nKeys.PSTWebDiscoverEnterPasswordLabel]: 'Enter Password...',
    [i18nKeys.PSTWebDiscoverUsernameLabel]: 'Username',
    [i18nKeys.PSTWebDiscoverEnterUsernameLabel]: 'Enter Username...',
    [i18nKeys.PSTWebDiscoverDirectoryLabel]: 'Directory',
    [i18nKeys.PSTWebDiscoverEnterDirectoryLabel]: 'Enter Directory...',
    [i18nKeys.PSTWebDiscoverTypeLabel]: 'Type',
    [i18nKeys.PSTWebDiscoverBAPLabel]: 'Browse available products...',
    [i18nKeys.PSTWebDiscoverEnterAccountNameLabel]: 'Enter Account Name...',
    [i18nKeys.PSTWebDiscoverRSSFeedLabel]: 'RSS Feed',
    [i18nKeys.PSTWebDiscoverWireFeedLabel]: 'Wire Feed',
    [i18nKeys.PSTWebDiscoverWireFeedsLabel]: 'Wire Feeds',
    [i18nKeys.PSTWebDiscoverTwitterFeedFeedLabel]: 'Twitter Feed',
    [i18nKeys.PSTWebDiscoverApFeedLabel]: 'AP Feed',
    [i18nKeys.PSTWebDiscoverFtpFeedLabel]: 'FTP Feed',

    // Discover Merlin Media Search Full Screen
    [i18nKeys.PSTWebDiscoverMerlinPhotosLabel]: 'Photos',
    [i18nKeys.PSTWebDiscoverMerlinVideosLabel]: 'Videos',
    [i18nKeys.PSTWebDiscoverMerlinEntitiesLabel]: 'Entities',

    // Topic Type
    [i18nKeys.PSTRundownStartTime]: 'Start Time',
    [i18nKeys.PSTWebLayoutLabel]: 'Layout',
    [i18nKeys.PSTWebProductionLabel]: 'Production',
    [i18nKeys.PSTWebListValue_PSTTopicType_NoType]: 'No Type',
    [i18nKeys.PSTWebSelectTopicTypesLabel]: 'Select Topic Types',

    // PST Story
    [i18nKeys.PSTWebAddStoryLabel]: 'Add Story',
    [i18nKeys.PSTWebGenerateANewVersion]: 'Generate a New Version',
    [i18nKeys.PSTWebActualTime]: 'Actual: ',
    [i18nKeys.PSTWebTextTime]: 'TRT',
    [i18nKeys.PSTWebWordsCount]: 'words',
    [i18nKeys.PSTWebBackToTopicLabel]: 'Back',
    [i18nKeys.PSTWebSelectedTextTime]: 'Selected Text:',
    [i18nKeys.PSTStoryDefaultTitle]: 'New Story',

    // PST Story Types
    [i18nKeys.PSTWebListValue_PSTStoryOutputType_Web]: 'Web',
    [i18nKeys.PSTWebListValue_PSTStoryOutputType_Script]: 'Script',
    [i18nKeys.PSTWebListValue_PSTStoryOutputType_Social]: 'Social',
    [i18nKeys.PSTWebListValue_PSTStoryOutputType_BROADCAST]: 'Broadcast',

    // Tags
    [i18nKeys.PSTWebAddTagLabel]: 'Add Tag',

    // Story Locking
    [i18nKeys.PSTWebLockingInProgress]: 'Locking...',
    [i18nKeys.PSTWebLockedSuccess]: 'Locked',
    [i18nKeys.PSTWebLockedByOtherUser]: 'Locked by',
    [i18nKeys.PSTWebOpenToEdit]: 'Open to Edit',
    [i18nKeys.PSTWebEditing]: 'Editing...',

    // Object Types
    [i18nKeys.PSTObjectTypeStory]: 'Story',
    [i18nKeys.PSTObjectTypeTopic]: 'Topic',
    [i18nKeys.PSTObjectTypeRundown]: 'Rundown',

    // Rich Text Editor Menu
    [i18nKeys.PSTEditorStoryMenu]: 'Story',
    [i18nKeys.PSTEditorStoryMenuView]: 'View',
    [i18nKeys.PSTEditorStoryMenuNew]: 'New',
    [i18nKeys.PSTEditorStoryMenuGenerate]: 'Generate',
    [i18nKeys.PSTEditorStoryMenuDuplicate]: 'Duplicate',
    [i18nKeys.PSTEditorStoryMenuCopy]: 'Copy',
    [i18nKeys.PSTEditorStoryMenuCopyToClipboard]: 'Copy to Clipboard',
    [i18nKeys.PSTEditorStoryMenuCopyStoryLink]: 'Copy Story Link',
    [i18nKeys.PSTEditorStoryMenuSave]: 'Save',
    [i18nKeys.PSTEditorStoryMenuSaveAsTemplate]: 'Save as Template',
    [i18nKeys.PSTEditorStoryMenuRename]: 'Rename',
    [i18nKeys.PSTEditorStoryMenuMove]: 'Move',
    [i18nKeys.PSTEditorStoryMenuDelete]: 'Delete',
    [i18nKeys.PSTEditorStoryMenuEdit]: 'Edit',
    [i18nKeys.PSTEditorStoryMenuUndo]: 'Undo',
    [i18nKeys.PSTEditorStoryMenuRedo]: 'Redo',
    [i18nKeys.PSTEditorStoryMenuCut]: 'Cut',
    [i18nKeys.PSTEditorStoryMenuPaste]: 'Paste',
    [i18nKeys.PSTEditorStoryMenuSelectAll]: 'Select All',
    [i18nKeys.PSTEditorStoryMenuFindAndReplace]: 'Find and Replace',
    [i18nKeys.PSTEditorStoryMenuListView]: 'List View',
    [i18nKeys.PSTEditorStoryMenuListSplitView]: 'Split View',
    [i18nKeys.PSTEditorStoryMenuListExpandAllElements]: 'Expand All Elements',
    [i18nKeys.PSTEditorStoryMenuListFullscreen]: 'Fullscreen',
    [i18nKeys.PSTEditorStoryMenuVOSOT]: 'VO:SOT',
    [i18nKeys.PSTEditorStoryMenuAnchor]: 'Anchor',
    [i18nKeys.PSTEditorStoryMenuDuration]: 'Duration',
    [i18nKeys.PSTEditorStoryMenuInsert]: 'Insert',
    [i18nKeys.PSTEditorStoryMenuTake]: 'Take',
    [i18nKeys.PSTEditorStoryMenuTech]: 'Tech',
    [i18nKeys.PSTEditorStoryMenuNotes]: 'Notes',
    [i18nKeys.PSTEditorStoryMenuReadRate]: 'Read Rate',
    [i18nKeys.PSTEditorStoryMenuLink]: 'Link',
    [i18nKeys.PSTEditorStoryMenuFormat]: 'Format',
    [i18nKeys.PSTEditorStoryMenuText]: 'Text',
    [i18nKeys.PSTEditorStoryMenuBold]: 'Bold',
    [i18nKeys.PSTEditorStoryMenuItalic]: 'Italic',
    [i18nKeys.PSTEditorStoryMenuUnderline]: 'Underline',
    [i18nKeys.PSTEditorStoryMenuStrikeThrough]: 'Strike Through',
    [i18nKeys.PSTEditorStoryMenuSuperscript]: 'Superscript',
    [i18nKeys.PSTEditorStoryMenuSubscript]: 'Subscript',
    [i18nKeys.PSTEditorStoryMenuTextSize]: 'Size',
    [i18nKeys.PSTEditorStoryMenuTextSizeIncreaseFontSize]: 'Increase Font Size',
    [i18nKeys.PSTEditorStoryMenuTextSizeDecreaseFontSize]: 'Decrease Font Size',
    [i18nKeys.PSTEditorStoryMenuTextCapitalization]: 'Capitalization',
    [i18nKeys.PSTEditorStoryMenuTextLowercase]: 'lowercase',
    [i18nKeys.PSTEditorStoryMenuTextUppercase]: 'UPPERCASE',
    [i18nKeys.PSTEditorStoryMenuTextTitlecase]: 'Title Case',
    [i18nKeys.PSTEditorStoryMenuAlignAndIndent]: 'Align and Indent',
    [i18nKeys.PSTEditorStoryMenuAlignLeft]: 'Align Left',
    [i18nKeys.PSTEditorStoryMenuAlignRight]: 'Align Right',
    [i18nKeys.PSTEditorStoryMenuAlignCenter]: 'Align Center',
    [i18nKeys.PSTEditorStoryMenuAlignJustify]: 'Align Justify',
    [i18nKeys.PSTEditorStoryMenuIndent]: 'Increase indent',
    [i18nKeys.PSTEditorStoryMenuOutdent]: 'Decrease indent',
    [i18nKeys.PSTEditorStoryMenuParagraphStyles]: 'Paragraph Styles',
    [i18nKeys.PSTEditorStoryMenuHeadline1]: 'Headline 1',
    [i18nKeys.PSTEditorStoryMenuHeadline2]: 'Headline 2',
    [i18nKeys.PSTEditorStoryMenuHeadline3]: 'Headline 3',
    [i18nKeys.PSTEditorStoryMenuApplyForParagraph]: 'Apply for Paragraph',
    [i18nKeys.PSTEditorStoryMenuClearFormatting]: 'Clear Formatting',
    [i18nKeys.OPCAudioContentLabel]: 'Audio',
    [i18nKeys.OPCStillContentLabel]: 'Still',
    [i18nKeys.OPCVideoContentLabel]: 'Video',
    [i18nKeys.PSTEditorStoryMenuProperties]: 'Properties',
    [i18nKeys.PSTWebNewRecordFileUploadWarningTitle]: 'Upload Warning',
    [i18nKeys.PSTWebNewRecordFileUploadWarningContent]: `You can't upload attachments when creating a new record.\n You can do this after the record is created.`,
};

export const enum i18nKeys {
    // PST Products Labels
    PSTWebApPlaybookLabel = 'PSTWebApPlaybookLabel',
    PSTWebApStorytellingLabel = 'PSTWebApStorytellingLabel',

    // PST Document Title Products Labels
    PSTWebApPlaybookTitleLabel = 'PSTWebApPlaybookTitleLabel',
    PSTWebApStorytellingTitleLabel = 'PSTWebApStorytellingTitleLabel',
    PSTWebPlaybookTitleLabel = 'PSTWebPlaybookTitleLabel',
    PSTWebCastTitleLabel = 'PSTWebCastTitleLabel',
    PSTWebSideBarTitleLabel = 'PSTWebSideBarTitleLabel',
    PSTWebDarkThemeTitleLabel = 'PSTWebDarkThemeTitleLabel',
    PSTWebLightThemeTitleLabel = 'PSTWebLightThemeTitleLabel',
    PSTWebDiscoverTitleLabel = 'PSTWebDiscoverTitleLabel',

    // PST Navigation
    PSTWebViewSettingsTitle = 'PSTWebViewSettingsTitle',
    PSTWebHideDetails = 'PSTWebHideDetails',
    PSTWebShowDetails = 'PSTWebShowDetails',
    PSTWebCopyToClipboard = 'PSTWebCopyToClipboard',

    // PST Login Page
    PSTWebRememberCredentials = 'PSTWebRememberCredentials',
    PSTAutoLoginCredentials = 'PSTAutoLoginCredentials',
    PSTWebUsernamePlaceholder = 'PSTWebUsernamePlaceholder',
    PSTWebPasswordPlaceholder = 'PSTWebPasswordPlaceholder',
    PSTWebLoginButton = 'PSTWebLoginButton',
    PSTWebCollapseAllLabel = 'PSTWebCollapseAllLabel',
    PSTWebExpandAllLabel = 'PSTWebExpandAllLabel',
    // PST Session
    PSTWebSessionExpiredTitle = 'PSTWebSessionExpiredTitle',
    PSTWebSessionExpiredMessage = 'PSTWebSessionExpiredMessage',

    // PST Top Bar
    PSTWebTeamSettingsLabel = 'PSTWebTeamSettingsLabel',
    PSTWebCopyViewToClipboard = 'PSTWebCopyViewToClipboard',

    // PST Side Bar
    PSTWebNewSectionLabel = 'PSTWebNewSectionLabel',
    PSTWebPadLockLabel = 'PSTWebPadLockLabel',
    PSTWebPadUnlockLabel = 'PSTWebPadUnlockLabel',
    PSTWebPlusButtonLabel = 'PSTWebPlusButtonLabel',
    PSTWebRenameRemoveTitle = 'PSTWebRenameRemoveTitle',
    PSTWebRenameLabel = 'PSTWebRenameLabel',
    PSTWebRemoveLabel = 'PSTWebRemoveLabel',
    PSTWebEditViewLabel = 'PSTWebEditViewLabel',
    PSTWebDuplicateLabel = 'PSTWebDuplicateLabel',
    PSTWebDuplicateAsTeamViewLabel = 'PSTWebDuplicateAsTeamViewLabel',

    // PST Search
    PSTWebSearchPlaceholder = 'PSTWebSearchPlaceholder',
    PSTWebRangeLabel = 'PSTWebRangeLabel',

    // PST DIALOG ABOUT
    PSTWebDialogAboutPlatformLabel = 'PSTWebDialogAboutPlatformLabel',
    PSTWebDialogAboutVersionLabel = 'PSTWebDialogAboutVersionLabel',
    PSTWebDialogAboutDownloadErrorLog = 'PSTWebDialogAboutDownloadErrorLog',
    PSTWebDialogAboutRights = 'PSTWebDialogAboutRights',
    PSTWebDialogAboutCloseLabel = 'PSTWebDialogAboutCloseLabel',

    // PST Save Planning View Menu
    PSTWebSaveViewSettings = 'PSTWebSaveViewSettings',
    PSTWebSaveAsViewSettings = 'PSTWebSaveAsViewSettings',
    PSTWebMakeDefaultView = 'PSTWebMakeDefaultView',
    PSTWebBrowsePlanningViews = 'PSTWebBrowsePlanningViews',
    PSTWebCreateNewView = 'PSTWebCreateNewView',
    PSTWebEditTeamSettings = 'PSTWebEditTeamSettings',

    PSTWebSaveAsTitleDefaultSuffix = 'PSTWebSaveAsTitleDefaultSuffix',

    // PST Team View Settings Menu
    PSTWebMakeTeamDefaultView = 'PSTWebMakeTeamDefaultView',
    PSTWebMakeGlobalDefaultView = 'PSTWebMakeGlobalDefaultView',

    PSTWebSaveTeamViewSettings = 'PSTWebSaveTeamViewSettings',
    PSTWebSaveAsTeamViewSettings = 'PSTWebSaveAsTeamViewSettings',
    PSTWebBrowseTeamPlanningViews = 'PSTWebBrowseTeamPlanningViews',
    PSTWebCreateNewTeamView = 'PSTWebCreateNewTeamView',
    PSTWebExitTeamSettings = 'PSTWebExitTeamSettings',

    PSTWebHideNavigationBar = 'PSTWebHideNavigationBar',
    PSTWebShowNavigationBar = 'PSTWebShowNavigationBar',

    PSTWebMapSettingsBar = 'PSTWebMapSettingsBar',

    PSTWebCreateNewViewTitle = 'PSTWebCreateNewViewTitle',
    PSTWebCreateNewViewShow = 'PSTWebCreateNewViewShow',
    PSTWebCreateNewViewLayout = 'PSTWebCreateNewViewLayout',
    PSTWebNewItemsToggleButton = 'PSTWebNewItemsToggleButton',
    PSTWebCreateNewViewTopicRadio = 'PSTWebCreateNewViewTopicRadio',
    PSTWebCreateNewViewAssignmentRadio = 'PSTWebCreateNewViewAssignmentRadio',
    PSTWebCreateNewViewTitlePlaceholder = 'PSTWebCreateNewViewTitlePlaceholder',

    PSTWebTopicsLabel = 'PSTWebTopicsLabel',
    PSTWebPublicationItemsLabel = 'PSTWebPublicationItemsLabel',
    PSTWebStoriesLabel = 'PSTWebStoriesLabel',
    PSTWebRundownsLabel = 'PSTWebRundownsLabel',
    PSTWebSuggestedMediaLabel = 'PSTWebSuggestedMediaLabel',
    PSTWebPluginsLabel = 'PSTWebPluginsLabel',
    PSTWebPropertiesLabel = 'PSTWebPropertiesLabel',

    // PST Personal Settings Menu
    PSTWebEditAvatar = 'PSTWebEditAvatar',
    PSTWebPersonalSettings = 'PSTWebPersonalSettings',
    PSTWebNotificationSettings = 'PSTWebNotificationSettings',
    PSTWebHelp = 'PSTWebHelp',
    PSTWebAbout = 'PSTWebAbout',
    PSTWebTeamMembers = 'PSTWebTeamMembers',
    PSTWebRegionAndLanguage = 'PSTWebRegionAndLanguage',
    PSTWebDefaultTimeZoneLabel = 'PSTWebDefaultTimeZoneLabel',
    PSTWebBrowserDefaultTimeZoneLabel = 'PSTWebBrowserDefaultTimeZoneLabel',
    PSTWebLanguageLabel = 'PSTWebLanguageLabel',
    PSTWebDefaultLanguageLabel = 'PSTWebDefaultLanguageLabel',
    PSTWebPublicationChannel = 'PSTWebPublicationChannel',
    PSTWebRTLOriantation = 'PSTWebRTLOriantation',
    PSTWebLTROriantation = 'PSTWebLTROriantation',
    PSTWebStartWeekDay = 'PSTWebStartWeekDay',

    PSTWebLogout = 'PSTWebLogout',

    PSTWebRemoveNavigationSectionLabel = 'PSTWebRemoveNavigationSectionLabel',
    PSTWebRemoveNavigationSectionText = 'PSTWebRemoveNavigationSectionText',

    // PST Notification Settings Menu
    PSTWebNotificationDescription = 'PSTWebNotificationDescription',
    PSTWebNotificationMobileLabel = 'PSTWebNotificationMobileLabel',
    PSTWebNotificationWebLabel = 'PSTWebNotificationWebLabel',
    PSTWebNotificationTextLabel = 'PSTWebNotificationTextLabel',
    PSTWebNotificationTextInputLabel = 'PSTWebNotificationTextInputLabel',
    PSTWebNotificationEmailLabel = 'PSTWebNotificationEmailLabel',
    PSTWebNotificationEmailInputLabel = 'PSTWebNotificationEmailInputLabel',

    // PSF Filter Panel
    PSTWebFilterLabel = 'PSTWebFilterLabel',
    PSTWebRequiredFiltersLabel = 'PSTWebRequiredFiltersLabel',
    PSTWebOptionalFiltersLabel = 'PSTWebOptionalFiltersLabel',
    PSTWebNoFiltersSelectedLabel = 'PSTWebNoFiltersSelectedLabel',
    PSTWebFilterRelationshipsLabel = 'PSTWebFilterRelationshipsLabel',
    PSTWebAssignmentsFilterLabel = 'PSTWebAssignmentsFilterLabel',
    PSTWebMissingAssignmentsFilterLabel = 'PSTWebMissingAssignmentsFilterLabel',
    PSTWebFilterRequiredLabel = 'PSTWebFilterRequiredLabel',
    PSTWebFilterOptionalLabel = 'PSTWebFilterOptionalLabel',
    PSTWebRefineSearchLabel = 'PSTWebRefineSearchLabel',
    PSTWebFirstX = 'PSTWebFirstX',
    PSTWebLoadAll = 'PSTWebLoadAll',
    PSTWebPinFilterLabel = 'PSTWebPinFilterLabel',
    PSTWebDeleteFilterLabel = 'PSTWebDeleteFilterLabel',
    PSTWebAddFilterLabel = 'PSTWebAddFilterLabel',
    PSTWebTimeLabel = 'PSTWebTimeLabel',
    PSTWebNextLabel = 'PSTWebNextLabel',
    PSTWebSelectAllLabel = 'PSTWebSelectAllLabel',
    PSTWebSectionNameLabel = 'PSTWebSectionNameLabel',
    PSTWebStartDateLabel = 'PSTWebStartDateLabel',
    PSTWebEndDateLabel = 'PSTWebEndDateLabel',

    // PST List Panel
    PSTWebSearchLabel = 'PSTWebSearchLabel',
    PSTWebGroupByWireProviderLabel = 'PSTWebGroupByWireProviderLabel',
    PSTWebSearchResultsLabel = 'PSTWebSearchResultsLabel',
    PSTWebGettingListLoaderLabel = 'PSTWebGettingListLoaderLabel',
    PSTWebNewLabel = 'PSTWebNewLabel',
    PSTWebNewFeedLabel = 'PSTWebNewFeedLabel',
    PSTWebTemplateLabel = 'PSTWebTemplateLabel',
    PSTWebGroupByLabel = 'PSTWebGroupByLabel',
    PSTWebGroupByDateLabel = 'PSTWebGroupByDateLabel',
    PSTWebGroupByTimeLabel = 'PSTWebGroupByTimeLabel',
    PSTWebSortByModTimeLabel = 'PSTWebSortByModTimeLabel',
    PSTWebSortByAlphabeticalLabel = 'PSTWebSortByAlphabeticalLabel',
    PSTWebSortByPubTimeLabel = 'PSTWebSortByPubTimeLabel',
    PSTWebGroupByChannelLabel = 'PSTWebGroupByChannelLabel',
    PSTWebGroupByOwnerLabel = 'PSTWebGroupByOwnerLabel',
    PSTWebGroupByStatusLabel = 'PSTWebGroupByStatusLabel',
    PSTWebGroupByDepartmentLabel = 'PSTWebGroupByDepartmentLabel',
    PSTWebGroupByRoleLabel = 'PSTWebGroupByRoleLabel',

    PSTWebGroupByWireCategoryLabel = 'PSTWebGroupByWireCategoryLabel',
    PSTWebGroupByWireTypeLabel = 'PSTWebGroupByWireTypeLabel',
    PSTWebViewLabel = 'PSTWebViewLabel',
    PSTWebSortByLabel = 'PSTWebSortByLabel',
    PSTWebSortOrderLabel = 'PSTWebSortOrderLabel',
    PSTWebGroupSortOrderLabel = 'PSTWebGroupSortOrderLabel',
    PSTWebViewCardsLabel = 'PSTWebViewCardsLabel',
    PSTWebViewCardLabel = 'PSTWebViewCardLabel',
    PSTWebViewCondensedLabel = 'PSTWebViewCondensedLabel',
    PSTWebViewListLabel = 'PSTWebViewListLabel',
    PSTWebViewTimelineLabel = 'PSTWebViewTimelineLabel',
    PSTWebViewMapLabel = 'PSTWebViewMapLabel',
    PSTWebViewTrendsLabel = 'PSTWebViewTrendsLabel',
    PSTWebViewTileLabel = 'PSTWebViewTileLabel',
    PSTWebOwnersLabel = 'PSTWebOwnersLabel',
    PSTWebSlugLabel = 'PSTWebSlugLabel',
    PSTWebTitleLabel = 'PSTWebTitleLabel',
    PSTWebSummaryLabel = 'PSTWebSummaryLabel',
    PSTWebDescriptionLabel = 'PSTWebDescriptionLabel',
    PSTWebStatusLabel = 'PSTWebStatusLabel',
    PSTWebSelectStatusLabel = 'PSTWebSelectStatusLabel',
    PSTWebDesksLabel = 'PSTWebDesksLabel',
    PSTWebAssignmentsLabel = 'PSTWebAssignmentsLabel',
    PSTWebNewItemLabel = 'PSTWebNewItemLabel',
    PSTWebNewItemsLabel = 'PSTWebNewItemsLabel',
    PSTWebMyNewTopics = 'PSTWebMyNewTopics',
    PSTWebRemoveDate = 'PSTWebRemoveDate',
    PSTWebSettingsBar = 'PSTWebSettingsBar',
    PSTWebSettingsApproveLabel = 'PSTWebSettingsApproveLabel',
    PSTWebCastTargetPublicationDT = 'PSTWebCastTargetPublicationDT',
    PSTWebCustomFieldLabel = 'PSTWebCustomFieldLabel',

    // PST Controls
    PSTWebSaveButtonLabel = 'PSTWebSaveButtonLabel',
    PSTWebSaveAndNextButtonLabel = 'PSTWebSaveAndNextButtonLabel',
    PSTWebSaveAsTemplateButtonLabel = 'PSTWebSaveAsTemplateButtonLabel',
    PSTWebCancelButtonLabel = 'PSTWebCancelButtonLabel',
    PSTWebCloseButtonLabel = 'PSTWebCloseButtonLabel',
    PSTWebBackButtonLabel = 'PSTWebBackButtonLabel',
    PSTWebConfirmButtonLabel = 'PSTWebConfirmButtonLabel',
    PSTWebBrowseButtonLabel = 'PSTWebBrowseButtonLabel',
    PSTWebApplyButtonLabel = 'PSTWebApplyButtonLabel',
    PSTWebOkButtonLabel = 'PSTWebOkButtonLabel',
    PSTWebInsertButtonLabel = 'PSTWebInsertButtonLabel',
    PSTWebStaffIDPlaceholder = 'PSTWebStaffIDPlaceholder',
    PSTWebSlugPlaceholder = 'PSTWebSlugPlaceholder',
    PSTWebSummaryPlaceholder = 'PSTWebSummaryPlaceholder',
    PSTWebStatusPlaceholder = 'PSTWebStatusPlaceholder',
    PSTWebDeskPlaceHolder = 'PSTWebDeskPlaceHolder',
    PSTWebTopicTypePlaceholder = 'PSTWebTopicTypePlaceholder',
    PSTWebModifiedPlaceholder = 'PSTWebModifiedPlaceholder',
    PSTWebNotesLabel = 'PSTWebNotesLabel',
    PSTWebNotesPlaceholder = 'PSTWebNotesPlaceholder',
    PSTWebAllOption = 'PSTWebAllOption',
    PSTWebAnyOption = 'PSTWebAnyOption',
    PSTWebNotAppliedOption = 'PSTWebNotAppliedOption',
    PSTWebNotAssignedOption = 'PSTWebNotAssignedOption',
    PSTWebMeOption = 'PSTWebMeOption',
    PSTWebBlankOption = 'PSTWebBlankOption',
    PSTWebTodayOption = 'PSTWebTodayOption',
    PSTWebTomorrowOption = 'PSTWebTomorrowOption',
    PSTWebYesOption = 'PSTWebYesOption',
    PSTWebNoOption = 'PSTWebNoOption',
    PSTWebValueLabel = 'PSTWebValueLabel',
    PSTWebThisWeekOption = 'PSTWebThisWeekOption',
    PSTWebNextWeekOption = 'PSTWebNextWeekOption',
    PSTWebWeekAfterNextOption = 'PSTWebWeekAfterNextOption',
    PSTWebTodayPlusMinusFiveOption = 'PSTWebTodayPlusMinusFiveOption',
    PSTWebFutureOption = 'PSTWebFutureOption',
    PSTWebTodayPlusFiveOption = 'PSTWebTodayPlusFiveOption',
    PSTWebTodayPlusSevenOption = 'PSTWebTodayPlusSevenOption',
    PSTWebDateNotAvailableOption = 'PSTWebDateNotAvailableOption',
    PSTWebAssignmentOwnerLabel = 'PSTWebAssignmentOwnerLabel',
    PSTWebAssignmentAddLabel = 'PSTWebAssignmentAddLabel',
    PSTWebCostTypeColumnLabel = 'PSTWebCostTypeColumnLabel',
    PSTWebCostColumnLabel = 'PSTWebCostColumnLabel',
    PSTWebCostCurrencyLabel = 'PSTWebCostCurrencyLabel',
    PSTWebClearAllLabel = 'PSTWebClearAllLabel',
    PSTWebClearAllItemsLabel = 'PSTWebClearAllItemsLabel',
    PSTWebCreateNewTemplateTitlePlaceholder = 'PSTWebCreateNewTemplateTitlePlaceholder',
    PSTWebCreateNewTemplateLabel = 'PSTWebCreateNewTemplateLabel',
    PSTWebSaveAsTeam = 'PSTWebSaveAsTeam',
    PSTWebSaveAsEnterprise = 'PSTWebSaveAsEnterprise',
    PSTWebLoadingLabel = 'PSTWebLoadingLabel',
    PSTWebCreateNewViewLabel = 'PSTWebCreateNewViewLabel',
    PSTWebUpdateViewLabel = 'PSTWebUpdateViewLabel',
    PSTWebDatePickerClearLabel = 'PSTWebDatePickerClearLabel',
    PSTWebPinItemButtonLabel = 'PSTWebPinItemButtonLabel',
    PSTWebSaveOption = 'PSTWebSaveOption',
    PSTWebDiscardOption = 'PSTWebDiscardOption',

    // PST Address Form
    PSTWebAddressDetails = 'PSTWebAddressDetails',
    PSTWebFormattedAddressPlaceholder = 'PSTWebFormattedAddressPlaceholder',
    PSTWebFormattedAddressLabel = 'PSTWebFormattedAddressLabel',

    PSTWebStreetAddressPlaceholder = 'PSTWebStreetAddressPlaceholder',
    PSTWebLocationNamePlaceholder = 'PSTWebLocationNamePlaceholder',
    PSTWebCityPlaceholder = 'PSTWebCityPlaceholder',
    PSTWebStatePlaceholder = 'PSTWebStatePlaceholder',
    PSTWebCountryPlaceholder = 'PSTWebCountryPlaceholder',

    PSTWebCustomCardStreetAddressPlaceholder = 'PSTWebCustomCardStreetAddressPlaceholder',
    PSTWebCustomCardLocationNamePlaceholder = 'PSTWebCustomCardLocationNamePlaceholder',
    PSTWebCustomCardCityPlaceholder = 'PSTWebCustomCardCityPlaceholder',
    PSTWebCustomCardStatePlaceholder = 'PSTWebCustomCardStatePlaceholder',
    PSTWebCustomCardCountryPlaceholder = 'PSTWebCustomCardCountryPlaceholder',

    // PST Topic hover button texts
    PSTWebTopicHoverDeleteText = 'PSTWebTopicHoverDeleteText',
    PSTWebTopicHoverDuplicateText = 'PSTWebTopicHoverDuplicateText',
    PSTWebTopicHoverCloneText = 'PSTWebTopicHoverCloneText',
    PSTWebTopicHoverExpandText = 'PSTWebTopicHoverExpandText',
    PSTWebTopicHoverSaveAsTemplateText = 'PSTWebTopicHoverSaveAsTemplateText',
    PSTWebTopicHoverCopyUrlToClipboardText = 'PSTWebTopicHoverCopyUrlToClipboardText',
    PSTWebAssignmentHoverCopyUrlToClipboardText = 'PSTWebAssignmentHoverCopyUrlToClipboardText',
    PSTWebAddNewTopicText = 'PSTWebAddNewTopicText',

    PSTWebTimeZoneLabel = 'PSTWebTimeZoneLabel',

    // PST Panes
    PSTWebTagsPane = 'PSTWebTagsPane',
    PSTWebCoverageAssignmentsPane = 'PSTWebCoverageAssignmentsPane',
    PSTWebAttachmentsPane = 'PSTWebAttachmentsPane',
    PSTWebContactsPane = 'PSTWebContactsPane',
    PSTWebLinksPane = 'PSTWebLinksPane',
    PSTWebAssignmentDetails = 'PSTWebAssignmentDetails',
    PSTWebStoriesPane = 'PSTWebStoriesPane',

    PSTWebListValue_PSTCoverageType_Text = 'PSTWebListValue_PSTCoverageType_Text',
    PSTWebListValue_PSTCoverageType_Photo = 'PSTWebListValue_PSTCoverageType_Photo',
    PSTWebListValue_PSTCoverageType_Video = 'PSTWebListValue_PSTCoverageType_Video',
    PSTWebListValue_PSTCoverageType_LiveVideo = 'PSTWebListValue_PSTCoverageType_LiveVideo',
    PSTWebListValue_PSTCoverageType_Audio = 'PSTWebListValue_PSTCoverageType_Audio',
    PSTWebListValue_PSTCoverageType_Graphic = 'PSTWebListValue_PSTCoverageType_Graphic',
    PSTWebListValue_PSTCoverageType_Interactive = 'PSTWebListValue_PSTCoverageType_Interactive',
    PSTWebListValue_PSTCoverageType_SocialPromotion = 'PSTWebListValue_PSTCoverageType_SocialPromotion',

    // PST Timeline Day labels (Display names)
    PSTWebMonday = 'PSTWebMonday',
    PSTWebTuesday = 'PSTWebTuesday',
    PSTWebWednesday = 'PSTWebWednesday',
    PSTWebThursday = 'PSTWebThursday',
    PSTWebFriday = 'PSTWebFriday',
    PSTWebSaturday = 'PSTWebSaturday',
    PSTWebSunday = 'PSTWebSunday',

    // PST Timeline Day labels (Display names)
    PSTWebMON = 'PSTWebMON',
    PSTWebTUE = 'PSTWebTUE',
    PSTWebWED = 'PSTWebWED',
    PSTWebTHU = 'PSTWebTHU',
    PSTWebFRI = 'PSTWebFRI',
    PSTWebSAT = 'PSTWebSAT',
    PSTWebSUN = 'PSTWebSUN',

    // PST Planning Views & Searches
    PSTWebPlanningViewsLabel = 'PSTWebPlanningViewsLabel',
    PSTWebPlanningViewsPaneLabel = 'PSTWebPlanningViewsPaneLabel',
    PSTWebSearchesPaneLabel = 'PSTWebSearchesPaneLabel',
    PSTWebCreateDateLabel = 'PSTWebCreateDateLabel',
    PSTWebRemoveFromNavigation = 'PSTWebRemoveFromNavigation',
    PSTWebAddToNavigation = 'PSTWebAddToNavigation',
    PSTWebDeleteViewState = 'PSTWebDeleteViewState',
    PSTWebDeletePlanningItemLabel = 'PSTWebDeletePlanningItemLabel',
    PSTWebCreatedInLabel = 'PSTWebCreatedInLabel',
    PSTWebGlobalLabel = 'PSTWebGlobalLabel',
    PSTWebPersonalLabel = 'PSTWebPersonalLabel',
    PSTWebAllLabel = 'PSTWebAllLabel',

    // PST View State
    PSTWebDefLayoutLabel = 'PSTWebDefLayoutLabel',
    PSTWebContentSortOrder = 'PSTWebContentSortOrder',
    PSTWebDefContGroupByCriteriaLabel = 'PSTWebDefContGroupByCriteriaLabel',
    PSTWebDefContSortByCriteriaLabel = 'PSTWebDefContSortByCriteriaLabel',
    PSTWebAddViewTitleLabel = 'PSTWebAddViewTitleLabel',
    PSTWebContentTypeLabel = 'PSTWebContentTypeLabel',
    PSTWebAdvancedSettingsLabel = 'PSTWebAdvancedSettingsLabel',
    PSTWebAddToViewLabel = 'PSTWebAddToViewLabel',
    PSTWebRemoveAllLabel = 'PSTWebRemoveAllLabel',
    PSTWebAddContentSourceLabel = 'PSTWebAddContentSourceLabel',
    PSTWebContentLabel = 'PSTWebContentLabel',
    PSTWebSelectContentSourceLabel = 'PSTWebSelectContentSourceLabel',
    PSTWebSingleContentViewSourceLabel = 'PSTWebSingleContentViewSourceLabel',
    PSTWebMultipleContentViewSourceLabel = 'PSTWebMultipleContentViewSourceLabel',
    PSTWebBrowseLabel = 'PSTWebBrowseLabel',
    PSTWebConfigureLabel = 'PSTWebConfigureLabel',
    PSTWebTotalResultsLabel = 'PSTWebTotalResultsLabel',

    // PST Confirmation Messages
    PSTWebConfirmDeleteKey = 'PSTWebConfirmDeleteKey',
    PSTWebConfirmDeleteLabel = 'PSTWebConfirmDeleteLabel',
    PSTWebConfirmDeletePart1 = 'PSTWebConfirmDeletePart1',
    PSTWebConfirmUnfreezePages = 'PSTWebConfirmUnfreezePages',
    PSTWebConfirmFreezePages = 'PSTWebConfirmFreezePages',
    PSTWebConfirmCancel = 'PSTWebConfirmCancel',
    PSTWebConfirmCancelShort = 'PSTWebConfirmCancelShort',
    PSTWebConfirmDeleteTopicPart2 = 'PSTWebConfirmDeleteTopicPart2',
    PSTWebConfirmDeleteAssignmentPart2 = 'PSTWebConfirmDeleteAssignmentPart2',
    PSTWebConfirmDeleteStoryPart2 = 'PSTWebConfirmDeleteStoryPart2',
    PSTWebConfirmDeleteStoryPart3 = 'PSTWebConfirmDeleteStoryPart3',
    PSTWebConfirmDeleteTemplatePart2 = 'PSTWebConfirmDeleteTemplatePart2',
    PSTWebConfirmSaveAsTemplatePart1 = 'PSTWebConfirmSaveAsTemplatePart1',
    PSTWebConfirmSaveAsTemplatePart2 = 'PSTWebConfirmSaveAsTemplatePart2',
    PSTWebConfirmChangeTopicGroup = 'PSTWebConfirmChangeTopicGroup',
    PSTWebClipboardModalTitle = 'PSTWebClipboardModalTitle',
    PSTWebClipboardModalPersonal = 'PSTWebClipboardModalPersonal',
    PSTWebClipboardModalTeam = 'PSTWebClipboardModalTeam',
    PSTWebClipboardModalEnterprise = 'PSTWebClipboardModalEnterprise',
    PSTWebConfirmDeletePublcationItem = 'PSTWebConfirmDeletePublcationItem',
    PSTWebConfirmSaveShort = 'PSTWebConfirmSaveShort',
    PSTWebConfirmSave = 'PSTWebConfirmSave',

    // PST Slideshow Labels
    PSTWebPlanningViewType = 'PSTWebPlanningViewType',
    PSTWebSingleViewLabel = 'PSTWebSingleViewLabel',
    PSTWebSlideshowViewLabel = 'PSTWebSlideshowViewLabel',
    PSTWebRefineSlideshowLabel = 'PSTWebRefineSlideshowLabel',
    PSTWebSlideshowDelayLabel = 'PSTWebSlideshowDelayLabel',
    PSTWebSlideshowIncludeInLabel = 'PSTWebSlideshowIncludeInLabel',
    PSTWebSecondsLabel = 'PSTWebSecondsLabel',
    PSTWebSlideshowsPaneLabel = 'PSTWebSlideshowsPaneLabel',

    // PST Manage Team Members
    PSTWebMTMLabel = 'PSTWebMTMLabel',
    PSTWebMTMPendingLabel = 'PSTWebMTMPendingLabel',
    PSTWebMTMActiveLabel = 'PSTWebMTMActiveLabel',
    PSTWebUserGroupSortByStatusLabel = 'PSTWebUserGroupSortByStatusLabel',
    PSTWebUserGroupSortByRoleLabel = 'PSTWebUserGroupSortByRoleLabel',
    PSTWebUserGroupSortByProgramLabel = 'PSTWebUserGroupSortByProgramLabel',
    PSTWebUserGroupSortByIDLabel = 'PSTWebUserGroupSortByIDLabel',
    PSTWebUserGroupSortByFirstNameLabel = 'PSTWebUserGroupSortByFirstNameLabel',
    PSTWebUserGroupSortByLastNameLabel = 'PSTWebUserGroupSortByLastNameLabel',
    PSTWebUserGroupSortByEmailLabel = 'PSTWebUserGroupSortByEmailLabel',
    PSTWebUserHeaderAvatarLabel = 'PSTWebUserHeaderAvatarLabel',
    PSTWebUserHeaderStatusLabel = 'PSTWebUserHeaderStatusLabel',
    PSTWebUserHeaderInvitationLabel = 'PSTWebUserHeaderInvitationLabel',
    PSTWebUserHeaderRoleLabel = 'PSTWebUserHeaderRoleLabel',
    PSTWebUserHeaderDefaultTeamLabel = 'PSTWebUserHeaderDefaultTeamLabel',
    PSTWebUserHeaderIDLabel = 'PSTWebUserHeaderIDLabel',
    PSTWebUserHeaderFirstNameLabel = 'PSTWebUserHeaderFirstNameLabel',
    PSTWebUserHeaderLastNameLabel = 'PSTWebUserHeaderLastNameLabel',
    PSTWebUserHeaderEmailLabel = 'PSTWebUserHeaderEmailLabel',
    PSTWebUserHeaderSSOEmailLabel = 'PSTWebUserHeaderSSOEmailLabel',
    PSTWebSendInvitationButtonLabel = 'PSTWebSendInvitationButtonLabel',
    PSTWebSendedInvitationButtonLabel = 'PSTWebSendedInvitationButtonLabel',
    PSTWebResendInvitationButtonLabel = 'PSTWebResendInvitationButtonLabel',
    PSTWebNewTeamMembersLabel = 'PSTWebNewTeamMembersLabel',
    PSTWebAddNewTeamMemberLabel = 'PSTWebAddNewTeamMemberLabel',
    PSTWebAllTeamMembersLabel = 'PSTWebAllTeamMembersLabel',
    PSTWebPendingTeamMembersLabel = 'PSTWebPendingTeamMembersLabel',
    PSTWebConfirmDeleteUserLabel = 'PSTWebConfirmDeleteUserLabel',
    PSTWebConfirmDeleteUserMessage = 'PSTWebConfirmDeleteUserMessage',
    PSTWebNewMemberLabel = 'PSTWebNewMemberLabel',
    PSTWebSaveMemberLabel = 'PSTWebSaveMemberLabel',
    PSTSystemConfiguration = 'PSTSystemConfiguration',

    // Manage publication channels
    PSTWebMPCHLabel = 'PSTWebMPCHLabel',
    PSTWebNPCHLabel = 'PSTWebNPCHLabel',
    PSTWebWorkFlowLabel = 'PSTWebWorkFlowLabel',
    PSTWebScheduleLabel = 'PSTWebScheduleLabel',
    PSTWebPublicationChannelName = 'PSTWebPublicationChannelName',
    PSTWebNameLabel = 'PSTWebNameLabel',
    PSTWebNameOfTeamLabel = 'PSTWebNameOfTeamLabel',
    PSTWebPublicationChannelSections = 'PSTWebPublicationChannelSections',

    PSTWebConfirmDeletePublicationLabel = 'PSTWebConfirmDeletePublicationLabel',
    PSTWebConfirmDeletePublicationMessage = 'PSTWebConfirmDeletePublicationMessage',

    PSTWebConfirmDeleteSectionLabel = 'PSTWebConfirmDeleteSectionLabel',
    PSTWebConfirmDeleteSectionMessage = 'PSTWebConfirmDeleteSectionMessage',

    PSTWebConfirmAddAllItemsLabel = 'PSTWebConfirmAddAllItemsLabel',
    PSTWebConfirmAddAllItemsMessage = 'PSTWebConfirmAddAllItemsMessage',

    PSTWebConfirmClearPublicationListLabel = 'PSTWebConfirmClearPublicationListLabel',
    PSTWebConfirmClearPublicationListMessage = 'PSTWebConfirmClearPublicationListMessage',

    PSTWebConfirmAddPublicationToRestrictedChannelLabel = 'PSTWebConfirmAddPublicationToRestrictedChannelLabel',
    PSTWebConfirmAddPublicationToRestrictedChannelMessage = 'PSTWebConfirmAddPublicationToRestrictedChannelMessage',
    PSTWebConfirmAddPublicationsToRestrictedChannelMessage = 'PSTWebConfirmAddPublicationsToRestrictedChannelMessage',

    PSTWebConfirmEditPublicationChannelMissingValueLabel = 'PSTWebConfirmEditPublicationChannelMissingValueLabel',
    PSTWebConfirmEditPublicationChannelMessage = 'PSTWebConfirmEditPublicationChannelMessage',

    // PST Attachments list
    PSTWebAttachmentsListDragFile = 'PSTWebAttachmentsListDragFile',
    // PST attachment rename
    PSTWebAttachmentRenameModalTitle = 'PSTWebAttachmentRenameModalTitle',
    PSTWebAttachmentRenameModalInputLabel = 'PSTWebAttachmentRenameModalInputLabel',

    // PST Native Android
    PSTWebFileSelectOptionsTitle = 'PSTWebFileSelectOptionsTitle',
    PSTWebFileSelectBrowseFiles = 'PSTWebFileSelectBrowseFiles',
    PSTWebFileSelectCapturePhoto = 'PSTWebFileSelectCapturePhoto',

    PSTWebDownloading = 'PSTWebDownloading',

    // Map layout
    PSTWebZoomToCoverageLabel = 'PSTWebZoomToCoverageLabel',
    PSTWebShowTeamLocationsLabel = 'PSTWebShowTeamLocationsLabel',
    PSTWebLockMapLocationLabel = 'PSTWebLockMapLocationLabel',

    PSTWebUploadFileNameTooLong = 'PSTWebUploadFileNameTooLong',

    PSTWebSortOrderTooltipASC = 'PSTWebSortOrderTooltipASC',
    PSTWebSortOrderTooltipDESC = 'PSTWebSortOrderTooltipDESC',

    PSTWebAttachmentOverLimitLabel = 'PSTWebAttachmentOverLimitLabel',
    PSTWebAttachmentOverLimitText = 'PSTWebAttachmentOverLimitText',
    PSTWebAllowedFileSizeText = 'PSTWebAllowedFileSizeText',
    PSTWebErrorUploadingFileLabel = 'PSTWebErrorUploadingFileLabel',
    PSTWebAllowedFileTypesText = 'PSTWebAllowedFileTypesText',

    PSTWebOpenFullScreenText = 'PSTWebOpenFullScreenText',
    PSTWebOpenText = 'PSTWebOpenText',
    PSTWebChangedAgoLabel = 'PSTWebChangedAgoLabel',
    PSTWebChangedByLabel = 'PSTWebChangedByLabel',
    PSTWebWordsLabel = 'PSTWebWordsLabel',
    PSTWebAddToTopicLabel = 'PSTWebAddToTopicLAbel',
    PSTWebAddToRundownLabel = 'PSTWebAddToRundownLabel',

    // Draft
    PSTStaffIDPlaceholder = 'PSTStaffIDPlaceholder',

    // PST Topic Custom Card Fields
    PSTWebSaveAsTeamDefault = 'PSTWebSaveAsTeamDefault',
    PSTWebSaveAsEnterpriseDefault = 'PSTWebSaveAsEnterpriseDefault',
    PSTWebCustomizeTopicCard = 'PSTWebCustomizeTopicCard',
    PSTWebSelectFieldLabel = 'PSTWebSelectFieldLabel',

    // Cast
    PSTWebStorytellingObjectsLabel = 'PSTWebStorytellingObjectsLabel',
    PSTWebSavedViewsLabel = 'PSTWebSavedViewsLabel',
    PSTWebCastSearchTabLabel = 'PSTWebCastSearchTabLabel',
    PSTWebSavedViewsTabLabel = 'PSTWebSavedViewsTabLabel',
    PSTWebRevisionsLabel = 'PSTWebRevisionsLabel',
    PSTWebPublishLabel = 'PSTWebPublishLabel',
    PSTWebEditSectionsLabel = 'PSTWebEditSectionsLabel',
    PSTWebSectionsLabel = 'PSTWebSectionsLabel',
    PSTWebCancelEditSectionsLabel = 'PSTWebCancelEditSectionsLabel',
    PSTWebSaveSectionsLabel = 'PSTWebSaveSectionsLabel',
    PSTWebCreateNewRevisionLabel = 'PSTWebCreateNewRevisionLabel',
    PSTWebNotPublished = 'PSTWebNotPublished',
    PSTWebPublishedAt = 'PSTWebPublishedAt',
    PSTWebPublishedAtByPSTWebPublishedAtBy = 'PSTWebPublishedAtByPSTWebPublishedAtBy',
    PSTWebPublishingStatus = 'PSTWebPublishingStatus',
    PSTWebChannelScheduleNotSupportedLabel = 'PSTWebChannelScheduleNotSupportedLabel',
    PSTWebChannelScheduleNotSupportedDetailLabel = 'PSTWebChannelScheduleNotSupportedDetailLabel',
    PSTWebPublicationListTitle = 'PSTWebPublicationListTitle',
    PSTWebPublicationChannelEditionNames = 'PSTWebPublicationChannelEditionNames',
    PSTWebPublicationChannelEditionName = 'PSTWebPublicationChannelEditionName',
    PSTWebPublicationChannelShowTopics = 'PSTWebPublicationChannelShowTopics',
    PSTWebPublicationChannelShowAssignments = 'PSTWebPublicationChannelShowAssignments',
    PSTWebPublicationChannelShowStories = 'PSTWebPublicationChannelShowStories',
    PSTWebPublicationChannelRemoveAddedRecords = 'PSTWebPublicationChannelRemoveAddedRecords',
    PSTWebAddAllLabel = 'PSTWebAddAllLabel',
    PSTWebCastObjectsDropDownLabel = 'PSTWebCastObjectsDropDownLabel',
    PSTWebCastObjectsCreatedBy = 'PSTWebCastObjectsCreatedBy',
    PSTWebCastObjectsOpenButton = 'PSTWebCastObjectsOpenButton',

    PSTWebCastLinkViolationErrorLabel = 'PSTWebCastLinkViolationErrorLabel',
    PSTWebErrorDeletingLabel = 'PSTWebErrorDeletingLabel',

    PSTWebCastErrorEditingSectionLabel = 'PSTWebCastErrorEditingSectionLabel',
    PSTWebCastSectionExistedText = 'PSTWebCastSectionExistedText',
    PSTWebCastSectionEmptyText = 'PSTWebCastSectionEmptyText',

    PSTWebChannelLabel = 'PSTWebChannelLabel',
    PSTWebDefaultViewLabel = 'PSTWebDefaultViewLabel',
    PSTWebViewSettingsLabel = 'PSTWebViewSettingsLabel',

    PSTWebWireFlagTooltip = 'PSTWebWireFlagTooltip',
    PSTWebWireTopicFromWireNavigateTooltip = 'PSTWebWireTopicFromWireNavigateTooltip',

    // Discover Wire Attachments full-screen
    PSTWebWireAttachmentsMediaName = 'PSTWebWireAttachmentsMediaName',
    PSTWebWireAttachmentsMediaType = 'PSTWebWireAttachmentsMediaType',
    PSTWebWireAttachmentsExitMediaMode = 'PSTWebWireAttachmentsExitMediaMode',
    PSTRundownStartTime = 'PSTRundownStartTime',
    PSTWebLayoutLabel = 'PSTWebLayoutLabel',
    PSTWebProductionLabel = 'PSTWebProductionLabel',
    PSTWebWireFullScreenGallery = 'PSTWebWireFullScreenGallery',
    PSTWebWireFullScreenStory = 'PSTWebWireFullScreenStory',
    PSTWebCreateNewDiscoverWireLabel = 'PSTWebCreateNewDiscoverWireLabel',
    PSTWebAttachDiscoverWireLabel = 'PSTWebAttachDiscoverWireLabel',
    PSTWebWireFullScreenWords = 'PSTWebWireFullScreenWords',
    PSTWebWireFullScreenAuthor = 'PSTWebWireFullScreenAuthor',
    PSTWebWireFullScreenAttachTo = 'PSTWebWireFullScreenAttachTo',

    // Discover Admin panel
    PSTWebDiscoverAdminSettingsLabel = 'PSTWebDiscoverAdminSettingsLabel',
    PSTWebDiscoverCredentialsLabel = 'PSTWebDiscoverCredentialsLabel',
    PSTWebDiscoverFeedsLabel = 'PSTWebDiscoverFeedsLabel',
    PSTWebDiscoverAddButton = 'PSTWebDiscoverAddButton',
    PSTWebDiscoverCreateButton = 'PSTWebDiscoverCreateButton',
    PSTWebDiscoverEditButton = 'PSTWebDiscoverEditButton',

    PSTWebDiscoverCreateFeedLabel = 'PSTWebDiscoverCreateFeedLabel',

    // Discover Create Credentials
    PSTWebDiscoverNewAccessTokenLabel = 'PSTWebDiscoverNewAccessTokenLabel',
    PSTWebDiscoverEditAccessTokenLabel = 'PSTWebDiscoverEditAccessTokenLabel',
    PSTWebDiscoverNewFeedLabel = 'PSTWebDiscoverNewFeedLabel',
    PSTWebDiscoverEditFeedLabel = 'PSTWebDiscoverEditFeedLabel',
    PSTWebDiscoverTokenConfigurationLabel = 'PSTWebDiscoverTokenConfigurationLabel',
    PSTWebDiscoverAddTokenNameLabel = 'PSTWebDiscoverAddTokenNameLabel',
    PSTWebDiscoverAddFeedNameLabel = 'PSTWebDiscoverAddFeedNameLabel',
    PSTWebDiscoverAPIKeyLabel = 'PSTWebDiscoverAPIKeyLabel',

    PSTWebDiscoverChooseFeedSourceLabel = 'PSTWebDiscoverChooseFeedSourceLabel',
    PSTWebDiscoverSelectAccessTokenLabel = 'PSTWebDiscoverSelectAccessTokenLabel',
    PSTWebDiscoverSelectProductsLabel = 'PSTWebDiscoverSelectProductsLabel',

    PSTWebDiscoverTokenNameLabel = 'PSTWebDiscoverTokenNameLabel',

    PSTWebDiscoverURLLabel = 'PSTWebDiscoverURLLabel',
    PSTWebDiscoverEnterURLLabel = 'PSTWebDiscoverEnterURLLabel',
    PSTWebDiscoverEnterURLHereLabel = 'PSTWebDiscoverEnterURLHereLabel',
    PSTWebDiscoverPasswordLabel = 'PSTWebDiscoverPasswordLabel',
    PSTWebDiscoverEnterPasswordLabel = 'PSTWebDiscoverEnterPasswordLabel',
    PSTWebDiscoverUsernameLabel = 'PSTWebDiscoverUsernameLabel',
    PSTWebDiscoverEnterUsernameLabel = 'PSTWebDiscoverEnterUsernameLabel',
    PSTWebDiscoverDirectoryLabel = 'PSTWebDiscoverDirectoryLabel',
    PSTWebDiscoverEnterDirectoryLabel = 'PSTWebDiscoverEnterDirectoryLabel',
    PSTWebDiscoverTypeLabel = 'PSTWebDiscoverTypeLabel',
    PSTWebDiscoverBAPLabel = 'PSTWebDiscoverBAPLabel',
    PSTWebDiscoverEnterAccountNameLabel = 'PSTWebDiscoverEnterAccountNameLabel',
    PSTWebDiscoverRSSFeedLabel = 'PSTWebDiscoverRSSFeedLabel',
    PSTWebDiscoverWireFeedLabel = 'PSTWebDiscoverWireFeedLabel',
    PSTWebDiscoverWireFeedsLabel = 'PSTWebDiscoverWireFeedsLabel',
    PSTWebDiscoverTwitterFeedFeedLabel = 'PSTWebDiscoverTwitterFeedFeedLabel',
    PSTWebDiscoverApFeedLabel = 'PSTWebDiscoverApFeedLabel',
    PSTWebDiscoverFtpFeedLabel = 'PSTWebDiscoverFtpFeedLabel',

    // Discover Merlin Media Search Full Screen
    PSTWebDiscoverMerlinPhotosLabel = 'PSTWebDiscoverMerlinPhotosLabel',
    PSTWebDiscoverMerlinVideosLabel = 'PSTWebDiscoverMerlinVideosLabel',
    PSTWebDiscoverMerlinEntitiesLabel = 'PSTWebDiscoverMerlinEntitiesLabel',

    // Topic Type
    PSTWebListValue_PSTTopicType_NoType = 'PSTWebListValue_PSTTopicType_NoType',
    PSTWebSelectTopicTypesLabel = 'PSTWebSelectTopicTypesLabel',

    // PST Story
    PSTWebAddStoryLabel = 'PSTWebAddStoryLabel',
    PSTWebGenerateANewVersion = 'PSTWebGenerateANewVersion',
    PSTWebActualTime = 'PSTWebActualTime',
    PSTWebTextTime = 'PSTWebTextTime',
    PSTWebWordsCount = 'PSTWebWordsCount',
    PSTWebBackToTopicLabel = 'PSTWebBackToTopicLabel',
    PSTWebSelectedTextTime = 'PSTWebSelectedTextTime',
    PSTStoryDefaultTitle = 'PSTStoryDefaultTitle',

    PSTWebListValue_PSTStoryOutputType_Web = 'PSTWebListValue_PSTStoryOutputType_Web',
    PSTWebListValue_PSTStoryOutputType_Script = 'PSTWebListValue_PSTStoryOutputType_Script',
    PSTWebListValue_PSTStoryOutputType_Social = 'PSTWebListValue_PSTStoryOutputType_Social',
    PSTWebListValue_PSTStoryOutputType_BROADCAST = 'PSTWebListValue_PSTStoryOutputType_Broadcast',

    // Tags
    PSTWebAddTagLabel = 'PSTWebAddTagLabel',

    // Story Locking
    PSTWebLockingInProgress = 'PSTWebLockingInProgress',
    PSTWebLockedSuccess = 'PSTWebLockedSuccess',
    PSTWebLockedByOtherUser = 'PSTWebLockedByOtherUser',
    PSTWebOpenToEdit = 'PSTWebOpenToEdit',
    PSTWebEditing = 'PSTWebEditing',

    // Object Types
    PSTObjectTypeStory = 'PSTObjectTypeStory',
    PSTObjectTypeTopic = 'PSTObjectTypeTopic',
    PSTObjectTypeRundown = 'PSTObjectTypeRundown',

    // Rich Text Editor Menu
    // Story
    PSTEditorStoryMenu = 'PSTEditorStoryMenu',
    PSTEditorStoryMenuNew = 'PSTEditorStoryMenuNew',
    PSTEditorStoryMenuGenerate = 'PSTEditorStoryMenuGenerate',
    PSTEditorStoryMenuDuplicate = 'PSTEditorStoryMenuDuplicate',
    PSTEditorStoryMenuCopy = 'PSTEditorStoryMenuCopy',
    PSTEditorStoryMenuCopyToClipboard = 'PSTEditorStoryMenuCopyToClipboard',
    PSTEditorStoryMenuCopyStoryLink = 'PSTEditorStoryMenuCopyStoryLink',
    PSTEditorStoryMenuSave = 'PSTEditorStoryMenuSave',
    PSTEditorStoryMenuSaveAsTemplate = 'PSTEditorStoryMenuSaveAsTemplate',
    PSTEditorStoryMenuRename = 'PSTEditorStoryMenuRename',
    PSTEditorStoryMenuMove = 'PSTEditorStoryMenuMove',
    PSTEditorStoryMenuDelete = 'PSTEditorStoryMenuDelete',
    //Edit
    PSTEditorStoryMenuView = 'PSTEditorStoryMenuView',
    PSTEditorStoryMenuEdit = 'PSTEditorStoryMenuEdit',
    PSTEditorStoryMenuUndo = 'PSTEditorStoryMenuUndo',
    PSTEditorStoryMenuRedo = 'PSTEditorStoryMenuRedo',
    PSTEditorStoryMenuCut = 'PSTEditorStoryMenuCut',
    PSTEditorStoryMenuPaste = 'PSTEditorStoryMenuPaste',
    PSTEditorStoryMenuSelectAll = 'PSTEditorStoryMenuSelectAll',
    PSTEditorStoryMenuFindAndReplace = 'PSTEditorStoryMenuFindAndReplace',
    PSTEditorStoryMenuListView = 'PSTEditorStoryMenuListView',
    PSTEditorStoryMenuListSplitView = 'PSTEditorStoryMenuListSplitView',
    PSTEditorStoryMenuListExpandAllElements = 'PSTEditorStoryMenuListExpandAllElements',
    PSTEditorStoryMenuListFullscreen = 'PSTEditorStoryMenuListFullscreen',
    //Insert
    PSTEditorStoryMenuVOSOT = 'PSTEditorStoryMenuVOSOT',
    PSTEditorStoryMenuAnchor = 'PSTEditorStoryMenuAnchor',
    PSTEditorStoryMenuDuration = 'PSTEditorStoryMenuDuration',
    PSTEditorStoryMenuInsert = 'PSTEditorStoryMenuInsert',
    PSTEditorStoryMenuTake = 'PSTEditorStoryMenuTake',
    PSTEditorStoryMenuTech = 'PSTEditorStoryMenuTech',
    PSTEditorStoryMenuNotes = 'PSTEditorStoryMenuNotes',
    PSTEditorStoryMenuReadRate = 'PSTEditorStoryMenuReadRate',
    PSTEditorStoryMenuLink = 'PSTEditorStoryMenuLink',
    //Format
    PSTEditorStoryMenuFormat = 'PSTEditorStoryMenuFormat',
    //Format Text
    PSTEditorStoryMenuText = 'PSTEditorStoryMenuText',
    PSTEditorStoryMenuBold = 'PSTEditorStoryMenuBold',
    PSTEditorStoryMenuItalic = 'PSTEditorStoryMenuItalic',
    PSTEditorStoryMenuUnderline = 'PSTEditorStoryMenuUnderline',
    PSTEditorStoryMenuStrikeThrough = 'PSTEditorStoryMenuStrikeThrough',
    PSTEditorStoryMenuSuperscript = 'PSTEditorStoryMenuSuperscript',
    PSTEditorStoryMenuSubscript = 'PSTEditorStoryMenuSubscript',
    //Format Text Size
    PSTEditorStoryMenuTextSize = 'PSTEditorStoryMenuTextSize',
    PSTEditorStoryMenuTextSizeIncreaseFontSize = 'PSTEditorStoryMenuTextSizeIncreaseFontSize',
    PSTEditorStoryMenuTextSizeDecreaseFontSize = 'PSTEditorStoryMenuTextSizeDecreaseFontSize',
    //Format Text Capitalization
    PSTEditorStoryMenuTextCapitalization = 'PSTEditorStoryMenuTextCapitalization',
    PSTEditorStoryMenuTextLowercase = 'PSTEditorStoryMenuTextLowercase',
    PSTEditorStoryMenuTextUppercase = 'PSTEditorStoryMenuTextUppercase',
    PSTEditorStoryMenuTextTitlecase = 'PSTEditorStoryMenuTextTitlecase',
    //Format Patagraph-Styles
    //Format Align-and-Indent
    PSTEditorStoryMenuAlignAndIndent = 'PSTEditorStoryMenuAlignAndIndent',
    PSTEditorStoryMenuAlignLeft = 'PSTEditorStoryMenuAlignLeft',
    PSTEditorStoryMenuAlignCenter = 'PSTEditorStoryMenuAlignCenter',
    PSTEditorStoryMenuAlignRight = 'PSTEditorStoryMenuAlignRight',
    PSTEditorStoryMenuAlignJustify = 'PSTEditorStoryMenuAlignJustify',
    PSTEditorStoryMenuIndent = 'PSTEditorStoryMenuIndent',
    PSTEditorStoryMenuOutdent = 'PSTEditorStoryMenuOutdent',
    PSTEditorStoryMenuParagraphStyles = 'PSTEditorStoryMenuParagraphStyles',
    PSTEditorStoryMenuHeadline1 = 'PSTEditorStoryMenuHeadline1',
    PSTEditorStoryMenuHeadline2 = 'PSTEditorStoryMenuHeadline2',
    PSTEditorStoryMenuHeadline3 = 'PSTEditorStoryMenuHeadline3',
    PSTEditorStoryMenuApplyForParagraph = 'PSTEditorStoryMenuApplyForParagraph',
    PSTEditorStoryMenuClearFormatting = 'PSTEditorStoryMenuClearFormatting',
    //Properties
    PSTEditorStoryMenuProperties = 'PSTEditorStoryMenuProperties',

    // EoF Rich Text Editor Menu
    OPCAudioContentLabel = 'OPCAudioContentLabel',
    OPCStillContentLabel = 'OPCStillContentLabel',
    OPCVideoContentLabel = 'OPCVideoContentLabel',
    PSTWebNewRecordFileUploadWarningTitle = 'PSTWebNewRecordFileUploadWarningTitle',
    PSTWebNewRecordFileUploadWarningContent = 'PSTWebNewRecordFileUploadWarningContent',
}
